import React, { useEffect, useRef, useState } from 'react'
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { BASE_URL } from '../config/axios';
import * as XLSX from 'xlsx';
import { Modal, Spinner } from 'react-bootstrap';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { formattedDateLong } from './Date';
import { CSSForSelectModern, formatCurrencyIndian, getMonthName, getMonthOptionss, handleErrorToast, ProgressModal, sortProjects, toOrdinal } from './CustomFunctions';
import { AddwithWhiteCircle, Calender, CircularGrid, DeleteDustbin, DropdownArrow, Location, UpdatePencil, HourGlass, Filter, SearchBig, AddwithBlueCircle, DropdownArrowOption, DownloadIcon, UploadIcon, Attachment, Refresh, Year, Month } from './AllSvg';
import { DeleteSiteEmployee, UpdateSiteEmployee } from './Wfm/WorkforceCrudButton';
import usePermission from '../config/permissions';
import { EmployeeFilter, MonthModern, Monthprefix0, Projects, SubCompany, SubCompanyModern, YearModern } from './FilterDropdown';
import { UploadOfficeRentBulk } from './SiteManagement/BulkModals';
import { DocumentModel } from './SiteManagement/ProjectDetailsCrudButtons';
import Select from "react-select";
import zIndex from '@mui/material/styles/zIndex';
import './Wfm/wfmcss/attendance.css'
import './Wfm/wfmcss/addattendance.css';
import './employeeCard.css';
import { AlertCircle, Briefcase, Calendar, ChevronDown, ChevronUp, ClipboardList, Clock, Download, DownloadCloud, FileText, Hash, Loader, Save, Search, Trash2, TrendingUp, Upload, Users, X } from 'lucide-react';
const UploadAttendance = ({ getVehicleBillingDetail }) => {

  const [show, setShow] = useState(false);


  const [buffer, setBuffering] = useState(false); //buffering logic
  const initialProject = "null";
  const [project, setProject] = useState(initialProject);
  const [projectList, setProjectList] = useState([]);

  const handleShow = () => {
    // getVehicle();

    setShow(true);
  }

  const handleClose = (event) => {
    if (event) {
      event.preventDefault();
    }
    setShow(false);

  }


  const monthOptions = [
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" }
  ];
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 20; // starting 20 years ago
  const endYear = currentYear + 20; // up to 20 years in the future
  const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);

  // ? *********** Handle File UPload ***********


  const [fileData, setFileData] = useState(null);
  const [jsonData, setJsonData] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState('');

  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        // Assuming the sheet with attendance data is named "Attendance"
        const worksheet = workbook.Sheets['Attendance'];
        const rawData = XLSX.utils.sheet_to_json(worksheet);

        // Transform rawData into the required format for uploading
        const transformedData = transformAttendanceData(rawData);
        setJsonData(transformedData);

        console.log(transformedData)
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const transformAttendanceData = (rawData) => {
    let transformedData = [];

    rawData.forEach((entry) => {
      const emp_code = entry.emp_code;


      // Loop through days of the month (assuming 1 to 31)
      for (let day = 1; day <= 31; day++) {
        if (entry[day]) {
          transformedData.push({
            emp_code: emp_code,
            date: `${selectedYear}-${selectedMonth.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`,
            status: entry[day],  // 'P', 'A', 'L', etc.
            in_time: null,  // Add if available in the data
            out_time: null  // Add if available in the data
          });
        }
      }
    });

    return transformedData;
  };
  const [error, setErrors] = useState()
  const [errormonth, setErrorsmonth] = useState()
  const [erroryear, setErrorsyear] = useState()
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!jsonData) {
      setErrors(' Please upload an Excel file first!');
      return;
    }

    if (!selectedMonth) {
      setErrorsmonth("Please select month")
      return;
    }


    if (!selectedYear) {
      setErrorsyear("Please select Year")
      return;
    }




    try {
      const response = await axios.post(`${BASE_URL}/siteproject/attendancepostbulk/`, { data: jsonData });
      alert('Attendance uploaded successfully!');
    } catch (error) {
      console.error('Error uploading attendance:', error);
      alert('Error uploading attendance.');
    }
  };


  return (


    <div>
      <>
        <button title='Upload Attendance' className='models-button model-add float-right' style={{ margin: 0 }} onClick={handleShow}>
          <AddwithBlueCircle />
        </button>

        <Modal show={show} onHide={handleClose} dialogClassName="request-leave  width-40vw">
          <Modal.Header closeButton>
            <Modal.Title>Upload Attendance</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
            <div className="parent-div">
              <div className="bdy-div">
                <form>
                  {/*   
                    <div title="Project" className="flex-column form-group-selectt">
                      <label htmlFor="project" className="form-labels  font-weight500    font-size-subheading">
                        Project<span className="required">*</span>
                      </label>
                      <br />
                      <select
                        type="text"
                        id="project"
                        name="project"
                        placeholder="project"
                        value={project}
                        onChange={(e) => setProject(e.target.value)}
                        className={`form-input form-group-selection ${errors.project ? "error" : inputState.project ? "success" : ""}`}
                      >
  
                        <option.sort value="null">Select a Project</option.sort>
                        {projectList?((a, b) => a.project_short_name.localeCompare(b.project_short_name, 'en', { ignorePunctuation: true })).map((i, index) => (
                          <option key={index} value={i.id}>{i.project_short_name}</option>
                        ))}
                      </select>
                      <div className="form-group-selection-arrow">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="25"
                          fill="currentColor"
                          className="bi bi-caret-down-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                        </svg>
                      </div>
                      {errors.project && <span className="error-message font-size-text ">{errors.project}</span>}
                    </div> */}


                  <div title="Month" className="flex-column form-group-selectt">
                    <label htmlFor="month" className="form-labels  font-weight500    font-size-subheading">
                      Month<span className="required">*</span>
                    </label>
                    <br />
                    <select
                      type="text"
                      id="month"
                      name="month"
                      placeholder="month"
                      value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}
                      className={`form-input form-group-selection}`}
                    >

                      <option value=""> Month</option>
                      {monthOptions.map((month) => (
                        <option key={month.id} value={month.id}>{month.name}</option>
                      ))}
                    </select>
                    <div className="form-group-selection-arrow">


                    </div>
                    {errormonth && <span className="error-message font-size-text ">{errormonth}</span>}
                  </div>
                  <div title="Year" className="flex-column form-group-selectt">
                    <label htmlFor="year" className="form-labels  font-weight500    font-size-subheading">
                      Year<span className="required">*</span>
                    </label>
                    <br />
                    <select
                      type="text"
                      id="year"
                      name="year"
                      placeholder="year"
                      value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}
                      className={`form-input form-group-selection }`}
                    >

                      <option value=""> Year</option>
                      {years.map((year) => (
                        <option key={year} value={year}>{year}</option>
                      ))}
                    </select>
                    <div className="form-group-selection-arrow">


                    </div>
                    {erroryear && <span className="error-message font-size-text ">{erroryear}</span>}
                  </div>

                  <div className="flex-column field-cont-div">
                    <label htmlFor="document_file" className="form-labels font-weight500 font-size-heading" title="Upload Bulk Attendance">
                      Upload Excel File
                    </label>
                    <label
                      htmlFor="document_file"
                      className="custom-file-upload"

                    >
                      {/* <div className="align-center pdf-input">
                        <Attachment />
                      </div> */}
                    </label>
                    <input type="file" accept=".xlsx, .xls" name="file" onChange={handleFileUpload} />
                    {error && <span className="error-message font-size-text ">{error}</span>}
                  </div>

                  <div className="button-models">
                    <button
                      className="model-button font-weight500 model-button-cancel"
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                    <button className="model-button-download model-button font-weight500" onClick={(e) => handleSubmit(e)}>Upload</button>
                  </div>


                </form>
              </div></div>
          </Modal.Body>
        </Modal>
      </>

    </div>


  )
}




const Attendanceee = () => {
  const [VehicleBillingDetails, setVehicleBillingDetails] = useState([]);
  const [buffer, setBuffering] = useState(false); //buffering logic
  const [project, setProject] = useState("null");
  const [search, setSearch] = useState("")
  const [projectList, setProjectList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filterMonth, setFilterMonth] = useState("");
  const [filterYear, setFilterYear] = useState("");
  const getProjects = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      // const pro = await axios.get(`${BASE_URL}/siteproject/project/`);
      const pro = await axios.get(
        sessionStorage.getItem('sitemanagement_role') === 'AuthorityEngineer' ?
          `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${sessionStorage.getItem('sitemanagement_emp_id')}/`
          : sessionStorage.getItem('sitemanagement_role') === 'DataEntryOperator' ?
            `${BASE_URL}/siteproject/projectfilterbycom_operator/${sessionStorage.getItem('sitemanagement_emp_id')}/`
            : `${BASE_URL}/siteproject/project/`
      );
      const sortedProjects = sortProjects(pro.data, 'site_prcode');
      setProjectList(sortedProjects);

    } catch (err) {
      //toast Logic
      handleErrorToast(err);
    } finally {
      setBuffering(false);// End Buffering
    }
  };
  const getVehicleBillingDetail = async () => {
    setBuffering(true);
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/filterbyprojvehiclebilling/${project}/`);
      setVehicleBillingDetails(response.data);
    }
    catch (err) {
      //toast Logic
      handleErrorToast(err);
    } finally {
      setBuffering(false);// End Buffering
    }
  }
  useEffect(() => {
    getVehicleBillingDetail();
    getProjects();
  }, [project]);

  const monthOptions = [
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" }
  ];
  const getMonthName = (monthNumber) => {
    const month = monthOptions.find(m => m.id.toString() === monthNumber);
    return month ? month.name : '';
  };

  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 20; // starting 20 years ago
  const endYear = currentYear + 20; // up to 20 years in the future
  const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);



  useEffect(() => {
    applyFilters();
  }, [search, filterMonth, filterYear, VehicleBillingDetails])


  const applyFilters = () => {
    let filteredData = VehicleBillingDetails;
    if (search !== "") {
      const lowercaseSelectedName = search.toLowerCase();
      filteredData = filteredData.filter(project => {
        const name = project.vehicle_name.toString().toLowerCase().includes(lowercaseSelectedName);
        const owner_name = project.vehicleownerdetails.toString().toLowerCase().includes(lowercaseSelectedName);
        return name || owner_name;
      });
    }
    if (filterMonth) {
      filteredData = filteredData.filter(project => project.month === filterMonth);

    }
    if (filterYear) {
      filteredData = filteredData.filter(project => project.year === filterYear);

    }






    setFilteredData(filteredData);
  };
  return (
    <div>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className="attendance-subcontainer margin">
        <div className="field-cont width-100vw justify-between">
          <div className="flex-row">
            <div title='Month Filter' className="field-cont-div">
              <Calender />

              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={filterMonth}
                onChange={(e) => setFilterMonth(e.target.value)}
              >
                <option value=""> Month</option>
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </select>

              <hr className="field-cont-hr" />
            </div>

            <div title='Year Filter' className="field-cont-div">
              <HourGlass />

              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={filterYear}
                onChange={(e) => setFilterYear(e.target.value)}
              >
                <option value="">Select Year</option>
                {years.map((year) => (
                  <option key={year} value={year}>{year}</option>
                ))}
              </select>

              <hr className="field-cont-hr" />
            </div>

            <div title="Project Filter " className="field-cont-div ">
              <Filter />
              <select
                id="project"
                name="project"
                placeholder="Project"
                value={project}
                onChange={(e) => setProject(e.target.value)}
                className={`attendance-input-field width-15vw`}
              >

                <option value="null">Select Project</option>
                {projectList?.sort((a, b) => a.project_short_name.localeCompare(b.project_short_name, 'en', { ignorePunctuation: true })).map((i, index) => (
                  <option key={index} value={i.id}>{i.project_short_name}</option>
                ))}
              </select>
              <hr className="field-cont-hr" />

            </div>

            <div title='Search Filter' className="field-cont-div">
              <SearchBig />
              <input className="attendance-input-field"
                placeholder='Search Name'
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)} />
              <hr className="field-cont-hr" />
            </div>
          </div>

          <div>
            <UploadAttendance getVehicleBillingDetail={getVehicleBillingDetail} />

          </div>
        </div>
      </div>

    </div>
  )

}


// const AddSiteAttendence = ({ getAttendance, i, subcompanyId }) => {


//   const [loading, setLoading] = useState(false);
//   const [show, setShow] = useState(false);
//   const [buffer, setBuffering] = useState(false);
//   const [employeeData, setEmployeeData] = useState([]);
//   const projectID = sessionStorage.getItem("sitemanagement_project_site_prcode")
//   const siteSubcompany = sessionStorage.getItem("sitemanagement_project_sub_company")


//   const [project, setProject] = useState(projectID ? projectID : "null");
//   const [selectedEmployee, setselectedEmployee] = useState("null");


//   const [formData, setFormData] = useState({
//     employee: "",
//     project: "",
//     total_days: "",
//     present_days: "",
//     man_months: "",
//     month: "",
//     year: "",
//   })


//   useEffect(() => {
//     setFormData((prev) => ({
//       ...prev,
//       project: project,
//       employee: selectedEmployee,
//     }));

//     setErrors((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       delete updatedErrors.project;
//       delete updatedErrors.employee;
//       return updatedErrors;
//     });
//   }, [project, selectedEmployee]);

//   useEffect(() => {
//     setFormData((prev) => ({
//       ...prev,
//       total_days: "",
//       present_days: "",
//     }))
//     setErrors((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       delete updatedErrors.total_days;
//       delete updatedErrors.present_days;
//       return updatedErrors;
//     });
//   }, [formData.month, formData.year])

//   const handleShow = () => {
//     setShow(true);
//   }
//   const handleClose = () => {
//     setFormData({
//       employee: "",
//       total_days: "",
//       man_months: "",
//       month: "",
//       year: "",
//     })
//     setErrors({});
//     setShow(false);
//     setProject("null");
//     setselectedEmployee("null")
//     setSuccess(false)
//   }
//   const isLeapYear = (year) => {
//     return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
//   };

//   const getDaysInMonth = (month, year) => {
//     return new Date(year, month, 0).getDate();
//   };




//   const [errors, setErrors] = useState({});
//   const [inputState, setInputState] = useState({});

//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const validateAttendenceForm = () => {
//     const newErrors = {};
//     const requiredFields = [

//       "employee",
//       "project",
//       "present_days",
//       "total_days",
//       "month",
//       "year",
//     ];

//     requiredFields.forEach((field) => {
//       const value = formData[field];
//       if (
//         value === undefined ||
//         value === null ||
//         value === "" ||
//         value === "null"
//       ) {
//         newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
//       }
//     });

//     const month = Number(formData.month);
//     const year = Number(formData.year);
//     const totalDays = Number(formData.total_days);

//     if (month && year && formData.total_days) {
//       const expectedDays = getDaysInMonth(month, year);

//       if (month === 2) {
//         const leap = isLeapYear(year);
//         if (!leap && totalDays !== 28) {
//           newErrors.total_days = `February ${year} is not a leap year. Must be 28 days`;
//         } else if (leap && totalDays !== 29) {
//           newErrors.total_days = `February ${year} is a leap year. Must be 29 days`;
//         }
//       } else {
//         if (totalDays !== expectedDays) {
//           newErrors.total_days = `Total days must be exactly ${expectedDays} for selected month`;
//         }
//       }
//     }

//     if (
//       formData.present_days &&
//       formData.total_days &&
//       Number(formData.present_days) > Number(formData.total_days)
//     ) {
//       newErrors.present_days = "Present days cannot be greater than total days";
//     }

//     setErrors(newErrors);
//     setIsSubmitted(true);

//     return Object.keys(newErrors).length === 0;
//   };
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     const updatedFormData = {
//       ...formData,
//       [name]: value,
//     };

//     const presentDays = parseFloat(name === "present_days" ? value : updatedFormData.present_days) || 0;
//     const totalDays = parseFloat(name === "total_days" ? value : updatedFormData.total_days) || 0;
//     if (presentDays && totalDays) {
//       updatedFormData.man_months = (presentDays / totalDays).toFixed(2);
//     } else {
//       updatedFormData.man_months = "";
//     }

//     setInputState({
//       ...inputState,
//       [name]: value.trim() ? "green" : "",
//     });

//     setFormData(updatedFormData);

//     setErrors((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       if (value) {
//         delete updatedErrors[name];
//       }
//       return updatedErrors;
//     });
//   };
//   const [uploadProgress, setUploadProgress] = useState(0);
//   const [showProgressModal, setShowProgressModal] = useState(false);
//   const [success, setSuccess] = useState(false)

//   const handlePost = async (e) => {
//     e.preventDefault();
//     if (validateAttendenceForm()) {
//       setShowProgressModal(true);
//       setLoading(true);
//       setUploadProgress(0);

//       const loadingToastId = toast.loading("Loading: Please wait...");

//       let progress = 0;
//       const interval = setInterval(() => {
//         progress += 10;
//         if (progress >= 100) {
//           progress = 100;
//           clearInterval(interval);
//         }
//         setUploadProgress(progress);
//       }, 100); // Smooth animation

//       try {
//         const res = await axios.post(`${BASE_URL}/siteproject/attendancesites/`, formData);

//         if (res.status === 200) {
//           await getAttendance();
//           handleClose();

//           setTimeout(() => {
//             toast.dismiss(loadingToastId);
//             toast.success("Data Added successfully.");
//           }, 1000);
//         } else {
//           throw new Error("Unexpected response status: " + res.status);
//         }

//       } catch (err) {
//         clearInterval(interval);
//         setUploadProgress(0);
//         handleErrorToast(err);
//       } finally {
//         clearInterval(interval);

//         setTimeout(() => {
//           setShowProgressModal(false);
//         }, 1500);

//         setLoading(false);
//         toast.dismiss(loadingToastId);
//       }
//     }
//   };







//   const years = Array.from({ length: 20 }, (v, i) => new Date().getFullYear() - i);

//   return (
//     <>
//       <ToastContainer
//         position="top-center"
//         autoClose={1000}
//         hideProgressBar={false}
//         newestOnTop={true}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//       />
//       <button title="Add Site BOQ Attendance" className="upload-svg" onClick={handleShow}>
//         <AddwithWhiteCircle />
//         {" "}BOQ Attendance
//       </button>
//       {
//         showProgressModal ?
//           <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" /> :
//           show === true ?
//             <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
//               <Modal.Header closeButton>
//                 <Modal.Title>Add Site BOQ Attendance Details</Modal.Title>
//               </Modal.Header>
//               <Modal.Body>
//                 <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
//                 <div className="parent-div">
//                   <div className="bdy-div">
//                     <form onSubmit={handlePost}>
//                       <Projects inputvalue="project" usedFor="form" toggleProject={project} setToggleProject={setProject} value="id" subcompany={subcompanyId} error={errors.project} SetErrors={setErrors} />
//                       {project !== "null" &&
//                         < EmployeeFilter inputvalue="employee" usedFor="form" project={project} toggleEmployee={selectedEmployee} toggleCompany={subcompanyId} settoggleEmployee={setselectedEmployee} error={errors.employee} value="id" extraLabel="Select Project First" />
//                       }
//                       <div title="Month" className="flex-column form-group-selectt">
//                         <label htmlFor="month" className="form-labels  font-weight500    font-size-subheading">
//                           Month<span className="required">*</span>
//                         </label>
//                         <br />
//                         <select
//                           id="month"
//                           name="month"
//                           value={formData.month}
//                           onChange={handleInputChange}
//                           className={`form-input form-group-selection ${errors.month ? "error" : inputState.month ? "success" : ""}`}
//                         >
//                           <option value="">Select a Month</option>
//                           {getMonthOptionss().map((month, index) => (
//                             <option key={index} value={month.id}>
//                               {month.name}
//                             </option>
//                           ))}
//                         </select>
//                         {/* <DropdownArrow /> */}
//                         <div>
//                           {errors.month && (
//                             <span className="error-message font-size-text ">{errors.month}</span>
//                           )}
//                         </div>
//                       </div>
//                       <div title="Year" className="flex-column form-group-selectt">
//                         <label htmlFor="year" className="form-labels  font-weight500    font-size-subheading">
//                           Year<span className="required">*</span>
//                         </label>
//                         <br />
//                         <select
//                           id="year"
//                           name="year"
//                           value={formData.year}
//                           onChange={handleInputChange}
//                           className={`form-input form-group-selection ${errors.year ? "error" : inputState.year ? "success" : ""
//                             }`}
//                         >
//                           <option value="">Select a Year</option>
//                           {years.map((year, index) => (
//                             <option key={index} value={year}>
//                               {year}
//                             </option>
//                           ))}
//                         </select>
//                         {/* <DropdownArrow /> */}
//                         <div>
//                           {errors.year && (
//                             <span className="error-message font-size-text ">{errors.year}</span>
//                           )}
//                         </div>
//                       </div>
//                       <div title="Total Days" className="flex-column">
//                         <label htmlFor="total_days" className="form-labels  font-weight500    font-size-subheading">
//                           Total Days<span className="required">*</span>
//                         </label>
//                         <input
//                           maxLength={20}
//                           type="number"
//                           id="total_days"
//                           name="total_days"
//                           placeholder="Total Days"
//                           onChange={handleInputChange}
//                           value={formData.total_days}
//                           className={`form-input ${errors.total_days
//                             ? "error"
//                             : inputState.total_days
//                               ? "success"
//                               : ""
//                             }`}
//                         />
//                         {errors.total_days && (
//                           <span className="error-message font-size-text ">{errors.total_days}</span>
//                         )}
//                       </div>

//                       <div title="Present Days" className="flex-column">
//                         <label htmlFor="present_days" className="form-labels  font-weight500    font-size-subheading">
//                           Present Days <span className="required">*</span>
//                         </label>
//                         <input
//                           type="number"
//                           id="present_days"
//                           name="present_days"
//                           placeholder="Present Days"
//                           onChange={handleInputChange}
//                           value={formData.present_days}
//                           className={`form-input ${errors.present_days
//                             ? "error"
//                             : inputState.present_days
//                               ? "success"
//                               : ""
//                             }`}
//                         />

//                         {errors.present_days && (
//                           <span className="error-message font-size-text ">{errors.present_days}</span>
//                         )}
//                       </div>
//                       <div title="Man Months" className="flex-column">
//                         <label htmlFor="man_months" className="form-labels  font-weight500    font-size-subheading">
//                           Man Months<span className="required">(Read-Only)</span>
//                         </label>
//                         <input
//                           type="number"
//                           id="man_months"
//                           name="man_months"
//                           disabled
//                           placeholder="Man Months"
//                           onChange={handleInputChange}
//                           value={formData.man_months}
//                           className={`form-input ${errors.man_months
//                             ? "error"
//                             : inputState.man_months
//                               ? "success"
//                               : ""
//                             }`}
//                         />

//                         {errors.man_months && (
//                           <span className="error-message font-size-text ">{errors.man_months}</span>
//                         )}
//                       </div>




//                       <div className="button-models">
//                         <button className="model-button  font-weight500    model-button-leave font-size-heading" type="submit" disabled={loading}>
//                           {loading ? 'Adding...' : 'Add'}
//                         </button>
//                       </div>
//                       <p className="error-message font-size-text">
//                         {isSubmitted && Object.keys(errors).length > 0 && (
//                           Object.keys(errors).length > 5 ? (
//                             <h5 className="text-center">Please fill all mandatory fields!</h5>
//                           ) : (

//                             <h6 className="text-center">
//                               {'Error in ' + Object.keys(errors).map((field) =>
//                                 field.charAt(0).toUpperCase() + field.slice(1)
//                               ).join(', ')}
//                             </h6>
//                           )
//                         )}
//                       </p>
//                     </form>
//                   </div>
//                 </div>

//               </Modal.Body>
//             </Modal> : ""
//       }
//     </>
//   )
// }

// const AddSiteAttendence = ({ getAttendance, i, subcompanyId }) => {
//   const [loading, setLoading] = useState(false);
//   const [show, setShow] = useState(false);
//   const [buffer, setBuffering] = useState(false);
//   const [employeeData, setEmployeeData] = useState([]);
//   const projectID = sessionStorage.getItem("sitemanagement_project");
//   const siteSubcompany = sessionStorage.getItem("sitemanagement_project_sub_company");

//   const [project, setProject] = useState(projectID ? projectID : "null");
//   const [selectedEmployee, setselectedEmployee] = useState("null");

//   const [formData, setFormData] = useState({
//     employee: "",
//     project: "",
//     total_days: "",
//     present_days: "",
//     man_months: "",
//     month: "",
//     year: "",
//   });

//   useEffect(() => {
//     setFormData((prev) => ({
//       ...prev,
//       project: project,
//       employee: selectedEmployee,
//     }));

//     setErrors((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       delete updatedErrors.project;
//       delete updatedErrors.employee;
//       return updatedErrors;
//     });
//   }, [project, selectedEmployee]);

//   useEffect(() => {
//     setFormData((prev) => ({
//       ...prev,
//       total_days: "",
//       present_days: "",
//     }));
//     setErrors((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       delete updatedErrors.total_days;
//       delete updatedErrors.present_days;
//       return updatedErrors;
//     });
//   }, [formData.month, formData.year]);

//   const handleShow = () => {
//     setShow(true);
//   };

//   const handleClose = () => {
//     setFormData({
//       employee: "",
//       total_days: "",
//       man_months: "",
//       month: "",
//       year: "",
//     });
//     setErrors({});
//     setShow(false);
//     setProject("null");
//     setselectedEmployee("null");
//     setSuccess(false);
//   };

//   const isLeapYear = (year) => {
//     return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
//   };

//   const getDaysInMonth = (month, year) => {
//     return new Date(year, month, 0).getDate();
//   };

//   const [errors, setErrors] = useState({});
//   const [inputState, setInputState] = useState({});
//   const [isSubmitted, setIsSubmitted] = useState(false);

//   const validateAttendenceForm = () => {
//     const newErrors = {};
//     const requiredFields = [
//       "employee",
//       "project",
//       "present_days",
//       "total_days",
//       "month",
//       "year",
//     ];

//     requiredFields.forEach((field) => {
//       const value = formData[field];
//       if (
//         value === undefined ||
//         value === null ||
//         value === "" ||
//         value === "null"
//       ) {
//         newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
//       }
//     });

//     const month = Number(formData.month);
//     const year = Number(formData.year);
//     const totalDays = Number(formData.total_days);

//     if (month && year && formData.total_days) {
//       const expectedDays = getDaysInMonth(month, year);

//       if (month === 2) {
//         const leap = isLeapYear(year);
//         if (!leap && totalDays !== 28) {
//           newErrors.total_days = `February ${year} is not a leap year. Must be 28 days`;
//         } else if (leap && totalDays !== 29) {
//           newErrors.total_days = `February ${year} is a leap year. Must be 29 days`;
//         }
//       } else {
//         if (totalDays !== expectedDays) {
//           newErrors.total_days = `Total days must be exactly ${expectedDays} for selected month`;
//         }
//       }
//     }

//     if (
//       formData.present_days &&
//       formData.total_days &&
//       Number(formData.present_days) > Number(formData.total_days)
//     ) {
//       newErrors.present_days = "Present days cannot be greater than total days";
//     }

//     setErrors(newErrors);
//     setIsSubmitted(true);

//     return Object.keys(newErrors).length === 0;
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     const updatedFormData = {
//       ...formData,
//       [name]: value,
//     };

//     const presentDays =
//       parseFloat(name === "present_days" ? value : updatedFormData.present_days) || 0;
//     const totalDays =
//       parseFloat(name === "total_days" ? value : updatedFormData.total_days) || 0;
//     if (presentDays && totalDays) {
//       updatedFormData.man_months = (presentDays / totalDays).toFixed(2);
//     } else {
//       updatedFormData.man_months = "";
//     }

//     setInputState({
//       ...inputState,
//       [name]: value.trim() ? "green" : "",
//     });

//     setFormData(updatedFormData);

//     setErrors((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       if (value) {
//         delete updatedErrors[name];
//       }
//       return updatedErrors;
//     });
//   };

//   const [uploadProgress, setUploadProgress] = useState(0);
//   const [showProgressModal, setShowProgressModal] = useState(false);
//   const [success, setSuccess] = useState(false);

//   const handlePost = async (e) => {
//     e.preventDefault();
//     if (validateAttendenceForm()) {
//       setShowProgressModal(true);
//       setLoading(true);
//       setUploadProgress(0);

//       const loadingToastId = toast.loading("Loading: Please wait...");

//       let progress = 0;
//       const interval = setInterval(() => {
//         progress += 10;
//         if (progress >= 100) {
//           progress = 100;
//           clearInterval(interval);
//         }
//         setUploadProgress(progress);
//       }, 100);

//       try {
//         const res = await axios.post(`${BASE_URL}/siteproject/attendancesites/`, formData);

//         if (res.status === 200) {
//           await getAttendance();
//           handleClose();

//           setTimeout(() => {
//             toast.dismiss(loadingToastId);
//             toast.success("Data Added successfully.");
//           }, 1000);
//         } else {
//           throw new Error("Unexpected response status: " + res.status);
//         }
//       } catch (err) {
//         clearInterval(interval);
//         setUploadProgress(0);
//         handleErrorToast(err);
//       } finally {
//         clearInterval(interval);

//         setTimeout(() => {
//           setShowProgressModal(false);
//         }, 1500);

//         setLoading(false);
//         toast.dismiss(loadingToastId);
//       }
//     }
//   };

//   const years = Array.from({ length: 20 }, (v, i) => new Date().getFullYear() - i);

//   return (
//     <>
//       <ToastContainer
//         position="top-center"
//         autoClose={1000}
//         hideProgressBar={false}
//         newestOnTop={true}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//       />

//       <button title="Add Site BOQ Attendance" className="btn-animated" onClick={handleShow}>
//         <ClipboardList size={16} />
//         {" "}BOQ Attendance
//       </button>

//       {showProgressModal ? (
//         <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" />
//       ) : show === true ? (
//         <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="lg">
//           <Modal.Header className="modern-modal-header">
//             <div className="header-content">
//               <div style={{ color: "white" }}>
//                 <ClipboardList size={24} />
//               </div>
//               <div>
//                 <Modal.Title>Add Site BOQ Attendance</Modal.Title>
//                 <p className="header-subtitle" style={{ color: "white" }}>
//                   Fill in the details to record attendance
//                 </p>
//               </div>
//             </div>
//             <button className="close-btn" onClick={handleClose}>
//               <X size={20} />
//             </button>
//           </Modal.Header>

//           <Modal.Body className="modern-modal-body">
//             <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

//             <form onSubmit={handlePost} className="project-form">
//               <div className="form-section">
//                 <div className="section-title">
//                   <ClipboardList size={18} />
//                   <h4>Attendance Details</h4>
//                 </div>
//                 <div className="form-grid">
//                   {sessionStorage.getItem("sitemanagement_role") !== "SiteManagement" &&
//                     <div className="form-field">
//                       <Projects
//                         inputvalue="project"
//                         usedFor="form"
//                         toggleProject={project}
//                         setToggleProject={setProject}
//                         value="id"
//                         subcompany={subcompanyId}
//                         error={errors.project}
//                         SetErrors={setErrors}
//                         cssType="modern"
//                       />
//                     </div>
//                   }

//                   {project !== "null" && (
//                     <div className="form-field">
//                       <EmployeeFilter
//                         inputvalue="employee"
//                         usedFor="form"
//                         project={project}
//                         toggleEmployee={selectedEmployee}
//                         toggleCompany={subcompanyId}
//                         settoggleEmployee={setselectedEmployee}
//                         error={errors.employee}
//                         value="id"
//                         cssType="modern"
//                         extraLabel="Select Project First"
//                       />
//                     </div>
//                   )}

//                   <div className="form-field">
//                     <label>
//                       <Calendar size={14} /> Month<span className="required">*</span>
//                     </label>
//                     <Select
//                       options={getMonthOptionss().map((month) => ({ value: month.id, label: month.name }))}
//                       isSearchable
//                       isClearable
//                       placeholder="Select a Month"
//                       value={
//                         getMonthOptionss()
//                           .map((month) => ({ value: month.id, label: month.name }))
//                           .find((opt) => opt.value === formData.month) || null
//                       }
//                       onChange={(selected) => {
//                         handleInputChange({
//                           target: { name: "month", value: selected ? selected.value : "" },
//                         });
//                       }}
//                       styles={CSSForSelectModern}
//                     />
//                     {errors.month && <span className="error-message">{errors.month}</span>}
//                   </div>

//                   <div className="form-field">
//                     <label>
//                       <Calendar size={14} /> Year<span className="required">*</span>
//                     </label>
//                     <Select
//                       options={years.map((year) => ({ value: year, label: String(year) }))}
//                       isSearchable
//                       isClearable
//                       placeholder="Select a Year"
//                       value={
//                         years
//                           .map((year) => ({ value: year, label: String(year) }))
//                           .find((opt) => opt.value === formData.year) || null
//                       }
//                       onChange={(selected) => {
//                         handleInputChange({
//                           target: { name: "year", value: selected ? selected.value : "" },
//                         });
//                       }}
//                       styles={CSSForSelectModern}
//                     />
//                     {errors.year && <span className="error-message">{errors.year}</span>}
//                   </div>

//                   <div className="form-field">
//                     <label>
//                       <Hash size={14} /> Total Days<span className="required">*</span>
//                     </label>
//                     <input
//                       maxLength={20}
//                       type="number"
//                       id="total_days"
//                       name="total_days"
//                       placeholder="Total Days"
//                       onChange={handleInputChange}
//                       value={formData.total_days}
//                       className={
//                         errors.total_days ? "error" : inputState.total_days ? "success" : ""
//                       }
//                     />
//                     {errors.total_days && (
//                       <span className="error-message">{errors.total_days}</span>
//                     )}
//                   </div>

//                   <div className="form-field">
//                     <label>
//                       <Hash size={14} /> Present Days<span className="required">*</span>
//                     </label>
//                     <input
//                       type="number"
//                       id="present_days"
//                       name="present_days"
//                       placeholder="Present Days"
//                       onChange={handleInputChange}
//                       value={formData.present_days}
//                       className={
//                         errors.present_days ? "error" : inputState.present_days ? "success" : ""
//                       }
//                     />
//                     {errors.present_days && (
//                       <span className="error-message">{errors.present_days}</span>
//                     )}
//                   </div>

//                   <div className="form-field">
//                     <label>
//                       <TrendingUp size={14} /> Man Months
//                       <span className="required">(Read-Only)</span>
//                     </label>
//                     <input
//                       type="number"
//                       id="man_months"
//                       name="man_months"
//                       disabled
//                       placeholder="Man Months"
//                       onChange={handleInputChange}
//                       value={formData.man_months}
//                       className={
//                         errors.man_months ? "error" : inputState.man_months ? "success" : ""
//                       }
//                     />
//                     {errors.man_months && (
//                       <span className="error-message">{errors.man_months}</span>
//                     )}
//                   </div>
//                 </div>

//                 <div className="form-actions">
//                   <div className="submit-buttons" style={{ marginLeft: "auto" }}>
//                     <button
//                       type="button"
//                       className="btn-secondaryy"
//                       onClick={handleClose}
//                     >
//                       Cancel
//                     </button>
//                     <button className="btn-primaryy" type="submit" disabled={loading}>
//                       {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
//                       <span>{loading ? "Adding..." : "Add"}</span>
//                     </button>
//                   </div>
//                 </div>

//                 {isSubmitted && Object.keys(errors).length > 0 && (
//                   <div className="tab-error-message" style={{ marginTop: "12px" }}>
//                     <AlertCircle size={14} />
//                     <span>
//                       {Object.keys(errors).length > 5
//                         ? "Please fill all mandatory fields!"
//                         : "Error in " +
//                         Object.keys(errors)
//                           .map((field) => field.charAt(0).toUpperCase() + field.slice(1))
//                           .join(", ")}
//                     </span>
//                   </div>
//                 )}
//               </div>
//             </form>
//           </Modal.Body>
//         </Modal>
//       ) : (
//         ""
//       )}
//     </>
//   );
// };


const AddSiteAttendence = ({ getAttendance, i, subcompanyId }) => {
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [buffer, setBuffering] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeLoading, setEmployeeLoading] = useState(false);
  const projectID = sessionStorage.getItem("sitemanagement_project");
  const siteSubcompany = sessionStorage.getItem("sitemanagement_project_sub_company");

  const [project, setProject] = useState(projectID ? projectID : "null");
  const [selectedEmployee, setselectedEmployee] = useState("null");

  const [formData, setFormData] = useState({
    employee: "",
    project: "",
    total_days: "",
    present_days: "",
    man_months: "",
    month: "",
    year: "",
  });

  // ---- Projects (API 1) ----
  const getProjectData = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/null/null/null/null/`
      );
      setProjectList(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getProjectData();
  }, []);

  // ---- Employees: project select hone par dono APIs merge ----
  const getEmployee = async () => {
    if (!project || project === "null") {
      setEmployeeData([]);
      return;
    }

    try {
      setEmployeeLoading(true);

      const [res1, res2] = await Promise.all([
        axios.get(`${BASE_URL}/siteproject/employeefilterbyproject/${project}/null/`),
        axios.get(`${BASE_URL}/siteproject/employeemultipleproject/${project}/`),
      ]);

      const list1 = Array.isArray(res1.data) ? res1.data : [];
      const list2 = Array.isArray(res2.data) ? res2.data : [];

      // Merge: same employee (id) ho to fields combine, warna add
      const map = new Map();
      [...list1, ...list2].forEach((emp) => {
        const key = emp.id ?? emp.emp_code;
        map.set(key, { ...map.get(key), ...emp });
      });

      setEmployeeData([...map.values()]);
    } catch (err) {
      console.log(err);
      setEmployeeData([]);
    } finally {
      setEmployeeLoading(false);
    }
  };

  useEffect(() => {
    getEmployee();
  }, [project]);

  // Project change hone par selected employee reset
  useEffect(() => {
    setselectedEmployee("null");
  }, [project]);

  const projectOptions = projectList.map((p) => ({
    value: String(p.id),
    label: p.project_short_name || p.project_name || p.name || String(p.id),
  }));

  const employeeOptions = [...employeeData]
    .sort((a, b) => Number(a.emp_code) - Number(b.emp_code))
    .map((emp) => ({
      value: emp.id,
      label: emp.emp_code ? `${emp.name} (${emp.emp_code})` : emp.name,
    }));

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      project: project,
      employee: selectedEmployee,
    }));

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.project;
      delete updatedErrors.employee;
      return updatedErrors;
    });
  }, [project, selectedEmployee]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      total_days: "",
      present_days: "",
    }));
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.total_days;
      delete updatedErrors.present_days;
      return updatedErrors;
    });
  }, [formData.month, formData.year]);

  const handleShow = () => {
    setShow(true);
  };

  const handleClose = () => {
    setFormData({
      employee: "",
      total_days: "",
      man_months: "",
      month: "",
      year: "",
    });
    setErrors({});
    setShow(false);
    setProject("null");
    setselectedEmployee("null");
    setEmployeeData([]);
    setSuccess(false);
  };

  const isLeapYear = (year) => {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  };

  const getDaysInMonth = (month, year) => {
    return new Date(year, month, 0).getDate();
  };

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateAttendenceForm = () => {
    const newErrors = {};
    const requiredFields = [
      "employee",
      "project",
      "present_days",
      "total_days",
      "month",
      "year",
    ];

    requiredFields.forEach((field) => {
      const value = formData[field];
      if (
        value === undefined ||
        value === null ||
        value === "" ||
        value === "null"
      ) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });

    const month = Number(formData.month);
    const year = Number(formData.year);
    const totalDays = Number(formData.total_days);

    if (month && year && formData.total_days) {
      const expectedDays = getDaysInMonth(month, year);

      if (month === 2) {
        const leap = isLeapYear(year);
        if (!leap && totalDays !== 28) {
          newErrors.total_days = `February ${year} is not a leap year. Must be 28 days`;
        } else if (leap && totalDays !== 29) {
          newErrors.total_days = `February ${year} is a leap year. Must be 29 days`;
        }
      } else {
        if (totalDays !== expectedDays) {
          newErrors.total_days = `Total days must be exactly ${expectedDays} for selected month`;
        }
      }
    }

    if (
      formData.present_days &&
      formData.total_days &&
      Number(formData.present_days) > Number(formData.total_days)
    ) {
      newErrors.present_days = "Present days cannot be greater than total days";
    }

    setErrors(newErrors);
    setIsSubmitted(true);

    return Object.keys(newErrors).length === 0;
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    const updatedFormData = {
      ...formData,
      [name]: value,
    };

    const presentDays =
      parseFloat(name === "present_days" ? value : updatedFormData.present_days) || 0;
    const totalDays =
      parseFloat(name === "total_days" ? value : updatedFormData.total_days) || 0;
    if (presentDays && totalDays) {
      updatedFormData.man_months = (presentDays / totalDays).toFixed(2);
    } else {
      updatedFormData.man_months = "";
    }

    setInputState({
      ...inputState,
      [name]: String(value ?? "").trim() ? "green" : "",
    });

    setFormData(updatedFormData);

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (value) {
        delete updatedErrors[name];
      }
      return updatedErrors;
    });
  };

  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [success, setSuccess] = useState(false);

  const handlePost = async (e) => {
    e.preventDefault();
    if (validateAttendenceForm()) {
      setShowProgressModal(true);
      setLoading(true);
      setUploadProgress(0);

      const loadingToastId = toast.loading("Loading: Please wait...");

      let progress = 0;
      const interval = setInterval(() => {
        progress += 10;
        if (progress >= 100) {
          progress = 100;
          clearInterval(interval);
        }
        setUploadProgress(progress);
      }, 100);

      try {
        const res = await axios.post(`${BASE_URL}/siteproject/attendancesites/`, formData);

        if (res.status === 200) {
          await getAttendance();
          handleClose();

          setTimeout(() => {
            toast.dismiss(loadingToastId);
            toast.success("Data Added successfully.");
          }, 1000);
        } else {
          throw new Error("Unexpected response status: " + res.status);
        }
      } catch (err) {
        clearInterval(interval);
        setUploadProgress(0);
        handleErrorToast(err);
      } finally {
        clearInterval(interval);

        setTimeout(() => {
          setShowProgressModal(false);
        }, 1500);

        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  const years = Array.from({ length: 20 }, (v, i) => new Date().getFullYear() - i);

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <button title="Add Site BOQ Attendance" className="btn-animated" onClick={handleShow}>
        <ClipboardList size={16} />
        {" "}BOQ Attendance
      </button>

      {showProgressModal ? (
        <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" />
      ) : show === true ? (
        <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="lg">
          <Modal.Header className="modern-modal-header">
            <div className="header-content">
              <div style={{ color: "white" }}>
                <ClipboardList size={24} />
              </div>
              <div>
                <Modal.Title>Add Site BOQ Attendance</Modal.Title>
                <p className="header-subtitle" style={{ color: "white" }}>
                  Fill in the details to record attendance
                </p>
              </div>
            </div>
            <button className="close-btn" onClick={handleClose}>
              <X size={20} />
            </button>
          </Modal.Header>

          <Modal.Body className="modern-modal-body">
            <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

            <form onSubmit={handlePost} className="project-form">
              <div className="form-section">
                <div className="section-title">
                  <ClipboardList size={18} />
                  <h4>Attendance Details</h4>
                </div>
                <div className="form-grid">
                  {sessionStorage.getItem("sitemanagement_role") !== "SiteManagement" && (
                    <div className="form-field">
                      <label>
                        <Hash size={14} /> Project<span className="required">*</span>
                      </label>
                      <Select
                        options={projectOptions}
                        isSearchable
                        isClearable
                        placeholder="Select a Project"
                        value={projectOptions.find((opt) => opt.value === String(project)) || null}
                        onChange={(selected) => {
                          setProject(selected ? selected.value : "null");
                        }}
                        styles={CSSForSelectModern}
                      />
                      {errors.project && <span className="error-message">{errors.project}</span>}
                    </div>
                  )}

                  {project !== "null" && (
                    <div className="form-field">
                      <label>
                        <Hash size={14} /> Employee<span className="required">*</span>
                      </label>
                      <Select
                        options={employeeOptions}
                        isSearchable
                        isClearable
                        isLoading={employeeLoading}
                        placeholder={employeeLoading ? "Loading employees..." : "Select an Employee"}
                        value={employeeOptions.find((opt) => opt.value === selectedEmployee) || null}
                        onChange={(selected) => {
                          setselectedEmployee(selected ? selected.value : "null");
                        }}
                        styles={CSSForSelectModern}
                      />
                      {errors.employee && <span className="error-message">{errors.employee}</span>}
                    </div>
                  )}

                  <div className="form-field">
                    <label>
                      <Calendar size={14} /> Month<span className="required">*</span>
                    </label>
                    <Select
                      options={getMonthOptionss().map((month) => ({ value: month.id, label: month.name }))}
                      isSearchable
                      isClearable
                      placeholder="Select a Month"
                      value={
                        getMonthOptionss()
                          .map((month) => ({ value: month.id, label: month.name }))
                          .find((opt) => opt.value === formData.month) || null
                      }
                      onChange={(selected) => {
                        handleInputChange({
                          target: { name: "month", value: selected ? selected.value : "" },
                        });
                      }}
                      styles={CSSForSelectModern}
                    />
                    {errors.month && <span className="error-message">{errors.month}</span>}
                  </div>

                  <div className="form-field">
                    <label>
                      <Calendar size={14} /> Year<span className="required">*</span>
                    </label>
                    <Select
                      options={years.map((year) => ({ value: year, label: String(year) }))}
                      isSearchable
                      isClearable
                      placeholder="Select a Year"
                      value={
                        years
                          .map((year) => ({ value: year, label: String(year) }))
                          .find((opt) => opt.value === formData.year) || null
                      }
                      onChange={(selected) => {
                        handleInputChange({
                          target: { name: "year", value: selected ? selected.value : "" },
                        });
                      }}
                      styles={CSSForSelectModern}
                    />
                    {errors.year && <span className="error-message">{errors.year}</span>}
                  </div>

                  <div className="form-field">
                    <label>
                      <Hash size={14} /> Total Days<span className="required">*</span>
                    </label>
                    <input
                      maxLength={20}
                      type="number"
                      id="total_days"
                      name="total_days"
                      placeholder="Total Days"
                      onChange={handleInputChange}
                      value={formData.total_days}
                      className={
                        errors.total_days ? "error" : inputState.total_days ? "success" : ""
                      }
                    />
                    {errors.total_days && (
                      <span className="error-message">{errors.total_days}</span>
                    )}
                  </div>

                  <div className="form-field">
                    <label>
                      <Hash size={14} /> Present Days<span className="required">*</span>
                    </label>
                    <input
                      type="number"
                      id="present_days"
                      name="present_days"
                      placeholder="Present Days"
                      onChange={handleInputChange}
                      value={formData.present_days}
                      className={
                        errors.present_days ? "error" : inputState.present_days ? "success" : ""
                      }
                    />
                    {errors.present_days && (
                      <span className="error-message">{errors.present_days}</span>
                    )}
                  </div>

                  <div className="form-field">
                    <label>
                      <TrendingUp size={14} /> Man Months
                      <span className="required">(Read-Only)</span>
                    </label>
                    <input
                      type="number"
                      id="man_months"
                      name="man_months"
                      disabled
                      placeholder="Man Months"
                      onChange={handleInputChange}
                      value={formData.man_months}
                      className={
                        errors.man_months ? "error" : inputState.man_months ? "success" : ""
                      }
                    />
                    {errors.man_months && (
                      <span className="error-message">{errors.man_months}</span>
                    )}
                  </div>
                </div>

                <div className="form-actions">
                  <div className="submit-buttons" style={{ marginLeft: "auto" }}>
                    <button
                      type="button"
                      className="btn-secondaryy"
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                    <button className="btn-primaryy" type="submit" disabled={loading}>
                      {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                      <span>{loading ? "Adding..." : "Add"}</span>
                    </button>
                  </div>
                </div>

                {isSubmitted && Object.keys(errors).length > 0 && (
                  <div className="tab-error-message" style={{ marginTop: "12px" }}>
                    <AlertCircle size={14} />
                    <span>
                      {Object.keys(errors).length > 5
                        ? "Please fill all mandatory fields!"
                        : "Error in " +
                        Object.keys(errors)
                          .map((field) => field.charAt(0).toUpperCase() + field.slice(1))
                          .join(", ")}
                    </span>
                  </div>
                )}
              </div>
            </form>
          </Modal.Body>
        </Modal>
      ) : (
        ""
      )}
    </>
  );
};

const GetAttendance = () => {
  const projectID = sessionStorage.getItem("sitemanagement_project")
  const [project, setProject] = useState(projectID ? projectID : "null");
  const [buffer, setBuffering] = useState(false);
  const [selectedEmployee, setselectedEmployee] = useState("null");
  const [siteAttendanceList, setSiteAttendanceList] = useState([]);
  const defaultMonth = (() => {
    const month = new Date().getMonth() + 1;
    return month < 10 ? `0${month}` : `${month}`;
  })();
  const [filterMonth, setFilterMonth] = useState(defaultMonth);
  const currentYear = new Date().getFullYear();
  const [filterYear, setFilterYear] = useState(currentYear);
  const startYear = currentYear - 20; // starting 20 years ago
  const endYear = currentYear  // up to 20 years in the future
  const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);
  const subcompanyId = sessionStorage.getItem('sitemanagement_project_sub_company');
  const [subId, setSubId] = useState("null")

  // ---------- Name search filter ----------
  const [selectedName, setSelectedName] = useState("");
  const [filteredAttendance, setFilteredAttendance] = useState([]);

  // ---------- Show/hide filters ----------
  const [showFilters, setShowFilters] = useState(true);

  const getAttendance = async () => {
    setBuffering(true); // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/attendancesitefilter/${project}/${filterMonth}/${filterYear}/${selectedEmployee}/${subId}/`);
      setSiteAttendanceList(res.data);

    } catch (err) {
      handleErrorToast(err);

    } finally {
      setBuffering(false);// End Buffering
    }
  };

  useEffect(() => {
    getAttendance();
  }, [filterMonth, filterYear, project, selectedEmployee, subId]);

  const applyFilters = () => {
    let filteredData = siteAttendanceList;

    if (selectedName) {
      const lowercaseSelectedName = selectedName.toLowerCase();
      filteredData = filteredData.filter((entry) =>
        entry.employee_name?.toLowerCase().includes(lowercaseSelectedName)
      );
    }

    setFilteredAttendance(filteredData);
  };

  useEffect(() => {
    applyFilters();
  }, [selectedName, siteAttendanceList]);

  const siteRole = sessionStorage.getItem("sitemanagement_role")

  // ---------- Clear all filters logic ----------
  const hasActiveFilters =
    (siteRole !== "SiteManagement" && project !== "null") ||
    (siteRole !== "SiteManagement" && subId !== "null") ||
    selectedEmployee !== "null" ||
    selectedName !== "" ||
    filterMonth !== defaultMonth ||
    filterYear !== currentYear;

  const clearAllFilters = () => {
    if (siteRole !== "SiteManagement") {
      setProject("null");
      setSubId("null");
    }
    setselectedEmployee("null");
    setSelectedName("");
    setFilterMonth(defaultMonth);
    setFilterYear(currentYear);
  };

  return (
    <>
      <div className="progress-modern-container">

        {showFilters && (
          <div className="filter-bar-attractive">

            {siteRole !== "SiteManagement" && (
              <div className={`filter-chip ${project !== "null" ? "active" : ""}`} style={{ backgroundColor: "white", paddingTop: '0px', paddingBottom: "0px" }}>
                <div className="filter-chip-content" style={{ backgroundColor: "white" }}>
                  <Projects usedFor="filter" toggleProject={project} setToggleProject={setProject} value="id" subcompany={subId} />
                </div>
              </div>
            )}

            {/* {project !== "null" && (
              <div className={`filter-chip ${selectedEmployee !== "null" ? "active" : ""}`} style={{ backgroundColor: "white", paddingTop: '0px', paddingBottom: "0px" }}>
                <div className="filter-chip-content" style={{ backgroundColor: "white" }}>
                  <EmployeeFilter usedFor="filter" project={project} toggleEmployee={selectedEmployee} settoggleEmployee={setselectedEmployee} value="id" toggleCompany={subId} />
                </div>
              </div>
            )} */}

            <div title='Year Filter' className="filter-chip" style={{ padding: '0px' }}>
              <div className="filter-chip-content">
                <YearModern filterYear={filterYear} setFilterYear={setFilterYear} cssType="modern" />

              </div>
            </div>

            <div title='Month Filter' className="filter-chip" style={{ padding: '0px' }}>
              <div className="filter-chip-content">
                <Monthprefix0 filterMonth={filterMonth} setFilterMonth={setFilterMonth} cssType="modern" />

              </div>
            </div>

            <div className="filter-chip" style={{ minWidth: '220px' }}>
              <div><Search size={13} /></div>
              <div style={{ width: '100%' }}>
                <input
                  className="modern-select"
                  style={{ width: '100%' }}
                  placeholder="Employee Name"
                  type="text"
                  value={selectedName}
                  onChange={(e) => setSelectedName(e.target.value)}
                />
              </div>
            </div>

            {hasActiveFilters && (
              <button className="clear-filters-btn" onClick={clearAllFilters}>
                <X size={13} />
                Clear
              </button>
            )}
          </div>
        )}

        {/* Stats + toggle + actions */}
        <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
          <div className="stats-minimal-row">
            <div className="stat-minimal-item">
              <Users size={14} />
              <span>Showing</span>
              <strong>{filteredAttendance?.length || 0} of {siteAttendanceList?.length || 0} entries</strong>
            </div>
          </div>

          <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
            <button
              className="toggle-filters-btn"
              onClick={() => setShowFilters(!showFilters)}
            >
              <Filter size={14} />
              <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
              {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
            </button>

            {siteRole !== "ViewAccess" && (
              <div className="att-actions">
                <AddSiteAttendence getAttendance={getAttendance} subcompanyId={subId} />
                <AddBulkboqAttendance getAttendance={getAttendance} project={project} setProject={setProject} subCompany={subId} />
              </div>
            )}
          </div>
        </div>

        <div className="att-card">
          <div className="att-table-header">
            <div className="att-table-title-group">
              <h2 className="att-table-title">Boq Attendance</h2>
            </div>
          </div>

          <div className="att-table-scroll">
            <table className="att-table">
              <thead>
                <tr className="att-thead-top">
                  <th>S.no.</th>
                  <th>Employee Name</th>
                  <th>Project Name</th>
                  <th>Month</th>
                  <th>Year</th>
                  <th>Total Days</th>
                  <th>Present Days</th>
                  <th>Man Months</th>
                  {siteRole !== "SiteManagement" && siteRole !== "ViewAccess" &&
                    <th className="att-th-center">Action</th>
                  }
                </tr>
              </thead>
              {buffer ? (
                <tbody>
                  <tr>
                    <td colSpan={siteRole !== "SiteManagement" && siteRole !== "ViewAccess" ? 9 : 8} style={{ padding: "64px 0" }}>
                      <div className="att-spinner-lg" />
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody>
                  {filteredAttendance?.map((i, index) => (
                    <React.Fragment key={index}>
                      <tr className={`att-row ${index % 2 === 0 ? "att-row--even" : "att-row--odd"}`}>
                        <td className="att-td">{index + 1}</td>
                        <td className="att-td att-td--strong">{i.employee_name}</td>
                        <td className="att-td">{i.project_short_name}</td>
                        <td className="att-td">{i.month}</td>
                        <td className="att-td">{i.year}</td>
                        <td className="att-td">{i.total_days}</td>
                        <td className="att-td">{i.present_days}</td>
                        <td className="att-td">{Number(i.man_months).toFixed(2)}</td>
                        {
                          siteRole !== "SiteManagement" && siteRole !== "ViewAccess" &&
                          <td className="att-td att-th-center">
                            <DeleteboqAttandance getAttendance={getAttendance} i={i} />
                          </td>
                        }
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              )}
            </table>
          </div>
        </div>
      </div>
    </>
  )
}







const UploadAttendanceBulk2 = ({ id, getAttendanceData }) => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const projectId = sessionStorage.getItem('sitemanagement_project');
  const role = sessionStorage.getItem('sitemanagement_role');

  const [fileName, setFileName] = useState("");
  const [fileSize, setFileSize] = useState("");
  const [excelJson, setExcelJson] = useState(null);
  const [docErrors, setDocErrors] = useState({});
  const [isDragging, setIsDragging] = useState(false);
  const [jsonData, setJsonData] = useState(null);
  const [uploading, setUploading] = useState(false);

  const fileInputRef = useRef(null);

  const today = new Date();
  today.setDate(today.getDate() - 1);
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const [monthh, setMonthh] = useState(`${month}`);
  const day = today.getDate();

  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 20;
  const endYear = currentYear + 20;
  const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);

  const bulktableRef = useRef(null);

  const formatFileSize = (bytes) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  const handleDownload = () => {
    const table = bulktableRef.current;
    const wb = XLSX.utils.table_to_book(table, { sheet: "Attendance Sheet" });
    const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

    const blob = new Blob([s2ab(wbout)], {
      type: "application/vnd.ms-excel",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Attendance Sheet Format.xls";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };

  const handleClose = () => {
    setFileName("");
    setFileSize("");
    setExcelJson(null);
    setJsonData(null);
    setDocErrors({});
    setShow(false);
  };

  const handleRemoveFile = () => {
    setFileName("");
    setFileSize("");
    setExcelJson(null);
    setJsonData(null);
    setDocErrors({});
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const processFile = (file) => {
    if (!file) return;
    const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
    if (!validFileTypes.includes(file.type)) {
      setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
      setFileName("");
      setFileSize("");
      return;
    }

    setFileName(file.name);
    setFileSize(formatFileSize(file.size));
    setDocErrors({});

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const worksheet = workbook.Sheets['Attendance Sheet'];
      const rawData = XLSX.utils.sheet_to_json(worksheet);
      const transformedData = transformAttendanceData(rawData);
      setJsonData(transformedData);
      setExcelJson(rawData);
    };
    reader.readAsArrayBuffer(file);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    processFile(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    processFile(file);
  };

  const transformAttendanceData = (rawData) => {
    let transformedData = [];

    rawData.forEach((entry) => {
      const emp_code = entry.emp_code;

      for (let day = 1; day <= 31; day++) {
        if (entry[day]) {
          transformedData.push({
            emp_code: emp_code,
            date: `${yearr}-${monthh.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`,
            status: entry[day],
            in_time: null,
            out_time: null
          });
        }
      }
    });

    return transformedData;
  };

  const handleSubmit = async () => {
    if (!jsonData) {
      setDocErrors({ document_file: "Please upload an Excel file first!" });
      return;
    }

    setUploading(true);
    const loadingToastId = toast.loading("Uploading: Please wait...");

    try {
      const response = await axios.post(`${BASE_URL}/siteproject/attendancepostbulk/`, { data: jsonData });
      if (response.status === 200) {
        toast.dismiss(loadingToastId);
        toast.success("Uploaded Successfully");
        handleClose();
        getAttendanceData();
      }
    } catch (error) {
      handleErrorToast(error);
    } finally {
      setUploading(false);
      toast.dismiss(loadingToastId);
    }
  };

  const monthOptions = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" }
  ];

  const yearOptions = years.map((y) => ({ value: y, label: `${y}` }));

  const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
    .toString()
    .padStart(2, "0")}`;
  var datearray = formattedDate.split("-");
  var newdate = datearray[0] + "-" + datearray[1] + "-" + datearray[2];

  const [yearr, setYearr] = useState(`${year}`);
  const [project, setProject] = useState(projectId ? projectId : "null");

  useEffect(() => {
    getAllattendancedata();
  }, [monthh, yearr]);

  const [allattendance, setAllattendance] = useState([]);
  const [buffer, setBuffering] = useState(true);
  const siteSubcompany = sessionStorage.getItem("sitemanagement_project_sub_company");

  const [projectList, setProjectList] = useState([]);

  const getproject = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/projectfilterbysubcompany/${siteSubcompany}/`);

      const splitCodeParts = (code) => {
        const parts = code.trim().split("/");
        const firstPart = parts.slice(0, -1).join("/");
        const lastPart = parts.pop();
        const match = lastPart.match(/^(\d+)?([A-Za-z]+)$/);
        if (match) {
          return {
            firstPart,
            numericPart: match[1] ? parseInt(match[1], 10) : 0,
            alphaPart: match[2]
          };
        }
        return { firstPart, numericPart: 0, alphaPart: "" };
      };

      const sortedList = response.data.sort((a, b) => {
        const aParts = splitCodeParts(a.site_prcode);
        const bParts = splitCodeParts(b.site_prcode);
        if (aParts.firstPart !== bParts.firstPart) {
          return aParts.firstPart.localeCompare(bParts.firstPart);
        }
        if (aParts.alphaPart !== bParts.alphaPart) {
          return aParts.alphaPart.localeCompare(bParts.alphaPart);
        }
        return aParts.numericPart - bParts.numericPart;
      });

      setProjectList(sortedList);
    } catch (error) {
      alert(error);
    }
  };

  let getAllattendancedata = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/monthlyattendnaceall/${monthh}/${yearr}/${project}/${siteSubcompany}/`
      );

      const getAlphaNumericParts = (code) => {
        const match = code.match(/^([A-Za-z]+)(\d+)$/);
        if (match) {
          return { alphaPart: match[1], numericPart: parseInt(match[2], 10) };
        } else {
          return { alphaPart: '', numericPart: 0 };
        }
      };

      const sortedList = res.data.sort((a, b) => {
        const { alphaPart: alphaA, numericPart: numericA } = getAlphaNumericParts(a.emp_code);
        const { alphaPart: alphaB, numericPart: numericB } = getAlphaNumericParts(b.emp_code);

        if (alphaA !== alphaB) {
          return alphaA.localeCompare(alphaB);
        } else {
          return numericA - numericB;
        }
      });
      setAllattendance(sortedList);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  const getAllDatesOfMonth = (month, year) => {
    const numberOfDaysInMonth = new Date(year, month, 0).getDate();
    const dates = [];
    const datees = [];

    for (let i = 1; i <= numberOfDaysInMonth; i++) {
      const date = new Date(year, month - 1, i);
      const day = date.getDate();
      const formatttedDatee = `${day.toString().padStart(2, "0")}`;
      datees.push({ date: formatttedDatee });
      const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;
      dates.push({ date: formattedDate });
    }

    return dates;
  };

  const dates = getAllDatesOfMonth(monthh, yearr).map((date, index) => ({
    ...date,
    index,
  }));

  const getAllDatessOfMonth = (month, year) => {
    const numberOfDaysInMonth = new Date(year, month, 0).getDate();
    const datees = [];

    for (let i = 1; i <= numberOfDaysInMonth; i++) {
      const date = new Date(year, month - 1, i);
      const day = date.getDate();
      const formatttedDatee = `${day.toString().padStart(2, "0")}`;
      datees.push({ date: formatttedDatee });
    }

    return datees;
  };

  const datees = getAllDatessOfMonth(monthh, yearr);

  useEffect(() => {
    getproject();
  }, []);

  useEffect(() => {
    getAllattendancedata();
  }, [project, yearr, monthh, siteSubcompany]);

  const [selectedIndex, setSelectedIndex] = useState(-1);

  const handleClick = (index) => {
    setSelectedIndex(index);
  };

  const projectOptions = projectList
    ?.sort((a, b) => a.project_short_name.localeCompare(b.project_short_name, 'en', { ignorePunctuation: true }))
    .map((i) => ({ value: i.id, label: i.project_short_name }));

  return (
    <>
      <button
        title="Upload Bulk Attendance"
        className="btn-animated"
        onClick={handleShow}
        style={{ margin: "2px" }}
      >
        <UploadIcon /> Bulk Attendance
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal model-width80vw" size="xl">
        <Modal.Header className="modern-modal-header">
          <div className="header-content">
            <div style={{ color: "white" }}>
              <Upload size={24} />
            </div>
            <div>
              <Modal.Title>Upload Bulk Attendance</Modal.Title>
              <p className="header-subtitle" style={{ color: "white" }}>Download the format, mark attendance and upload it back</p>
            </div>
          </div>
          <button className="close-btn" onClick={handleClose}>
            <X size={20} />
          </button>
        </Modal.Header>

        <Modal.Body className="modern-modal-body">

          <div className="ub-download-row">
            <p><FileText size={14} style={{ marginRight: '6px', verticalAlign: 'middle' }} />
              Select project, month & year to download the attendance sheet, mark attendance, then upload it below.
            </p>
            <button onClick={handleDownload} className="btn-primaryy" type="button" style={{ flexShrink: 0 }}>
              <Download size={16} />
              <span>Format</span>
            </button>
          </div>

          <div className="section-title">
            <Calendar size={18} />
            <h4>Select Period</h4>
          </div>

          <div className="form-grid">
            {role !== "SiteManagement" && (
              <div className="form-field">
                <label><Briefcase size={14} /> Project<span className="required">*</span></label>
                <Select
                  options={projectOptions}
                  isSearchable
                  isClearable
                  placeholder="Select a Project"
                  value={projectOptions?.find((opt) => opt.value === project) || null}
                  onChange={(selected) => setProject(selected ? selected.value : "null")}
                  styles={CSSForSelectModern}
                />
              </div>
            )}

            <div className="form-field">
              <label><Calendar size={14} /> Month<span className="required">*</span></label>
              <Select
                options={monthOptions}
                isSearchable
                placeholder="Select a Month"
                value={monthOptions.find((opt) => opt.value === Number(monthh)) || null}
                onChange={(selected) => setMonthh(selected ? `${selected.value}` : "")}
                styles={CSSForSelectModern}
              />
            </div>

            <div className="form-field">
              <label><Calendar size={14} /> Year<span className="required">*</span></label>
              <Select
                options={yearOptions}
                isSearchable
                placeholder="Select a Year"
                value={yearOptions.find((opt) => opt.value === Number(yearr)) || null}
                onChange={(selected) => setYearr(selected ? `${selected.value}` : "")}
                styles={CSSForSelectModern}
              />
            </div>
          </div>

          <div className="table-css-white-background" style={{ display: "none" }}>
            <table ref={bulktableRef} id="my-table" style={{ borderColor: "#323232", borderRadius: "5px", padding: "0px 5px", borderWidth: "1px" }}>
              <thead>
                <tr>
                  <th className="summary-excel-tab br-5">emp_code</th>
                  <th className="summary-excel-tab br-5">Name</th>
                  <th className="summary-excel-tab br-5">Joining Date</th>
                  <th className="summary-excel-tab br-5"> Designation Name</th>
                  {datees.map((date) => (
                    <th className="summary-excel-tab br-5" key={date.date}>
                      {date.date}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {allattendance
                  .sort((a, b) => a.emp_code - b.emp_code)
                  .map((data, index) => {
                    const inactivename = data.employee_status === "inactive" ? "#ff1212" : "black";

                    return (
                      <tr
                        key={index}
                        style={{
                          backgroundColor: index === selectedIndex ? "yellow" : "white",
                          color: inactivename,
                        }}
                        onClick={() => handleClick(index)}
                      >
                        <td className="summary-excel-tab br-5">{data.emp_code}</td>
                        <td className="summary-excel-tab br-5">{data.name}</td>
                        <td className="summary-excel-tab br-5">{data.joining_date}</td>
                        <td className="summary-excel-tab br-5">{data.desigantion_name}</td>

                        {dates.map((date) => {
                          const attendanceForDate = data.attendances.find(
                            (attendance) => attendance.date === date.date
                          );

                          const attendanceStatus = attendanceForDate
                            ? attendanceForDate.status === "P"
                              ? "present"
                              : attendanceForDate.status === "A"
                                ? "absent"
                                : attendanceForDate.status === "L"
                                  ? "leave"
                                  : attendanceForDate.status === "W"
                                    ? "weeklyoff"
                                    : attendanceForDate.status === "H"
                                      ? "holiday"
                                      : attendanceForDate.status.slice(0, 2)
                            : "-";

                          const inTime = attendanceForDate?.in_time ?? "-";
                          const outTime = attendanceForDate?.out_time ?? "-";
                          const attstat = attendanceForDate?.status ?? "-";

                          return (
                            <td
                              key={date.date}
                              style={{
                                backgroundColor: index === selectedIndex ? "yellow" : "",
                                color: index === selectedIndex ? "black" : "",
                              }}
                              data-status={attendanceStatus}
                              className="behavior summary-excel-tab"
                              title={`Date: ${date.date}\nIn Time: ${inTime}\nOut Time: ${outTime}\nAttendance Status: ${attstat}\n`}
                            >
                              {attstat}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div className="section-title">
            <Upload size={18} />
            <h4>Upload File</h4>
          </div>

          <div
            className={`ub-upload-zone ${isDragging ? 'dragging' : ''} ${docErrors.document_file ? 'has-error' : ''}`}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            onClick={() => fileInputRef.current?.click()}
          >
            <div className="ub-upload-icon-circle">
              <Upload size={24} />
            </div>
            <p className="ub-upload-title">
              Drag & drop your Excel file here
            </p>
            <p className="ub-upload-subtitle">
              or <span className="ub-upload-browse">browse</span> to choose a file &nbsp;·&nbsp; .xlsx or .xls
            </p>
            <input
              ref={fileInputRef}
              id="document_file"
              name="document_file"
              type="file"
              accept=".xlsx, .xls"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
          </div>

          {docErrors.document_file && (
            <div className="tab-error-message" style={{ marginTop: '10px' }}>
              <AlertCircle size={14} />
              <span>{docErrors.document_file}</span>
            </div>
          )}

          {fileName && !docErrors.document_file && (
            <div className="ub-file-card">
              <div className="ub-file-icon">
                <FileText size={20} />
              </div>
              <div className="ub-file-info">
                <div className="ub-file-name">{fileName}</div>
                <div className="ub-file-size">{fileSize}{jsonData ? ` · ${jsonData.length} attendance entries found` : ''}</div>
              </div>
              <button type="button" className="ub-file-remove" onClick={handleRemoveFile} title="Remove file">
                <X size={18} />
              </button>
            </div>
          )}

          {excelJson && excelJson.length > 0 && (
            <>
              <div className="ub-preview-header">
                <div className="section-title" style={{ marginBottom: 0 }}>
                  <Users size={18} />
                  <h4 style={{ margin: 0 }}>Preview</h4>
                </div>
                <span className="ub-preview-badge">{excelJson.length} employees</span>
              </div>

              {/* <div className="ub-preview-wrap">
                <div className="ub-preview-scroll table-box scroll-container-table">
                  <table className="ub-preview-table">
                    <thead className="table-heading">
                      <tr>
                        <th>Emp Code</th>
                        {Object.keys(excelJson[0] || {}).filter(k => k !== "emp_code").map((key) => (
                          <th key={key}>{key}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {excelJson.map((employee, index) => (
                        <tr key={index}>
                          <td>{employee.emp_code}</td>
                          {Object.keys(employee).filter(k => k !== "emp_code").map((key) => (
                            <td key={key}>{employee[key]}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div> */}
            </>
          )}

          <div className="form-actions">
            <button type="button" className="btn-secondaryy" onClick={handleClose}>
              Cancel
            </button>
            <button type="button" className="btn-primaryy" onClick={handleSubmit} disabled={!jsonData || uploading}>
              {uploading ? <Loader size={18} className="spinning" /> : <Upload size={18} />}
              <span>{uploading ? 'Uploading...' : 'Upload'}</span>
            </button>
          </div>

          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};






// const AddBulkboqAttendance = ({ getAttendance, i, project, setProject, subCompany }) => {

//   const [show, setShow] = useState(false);
//   const [projectList, setProjectList] = useState([]);
//   const [employeeList, setEmployeeData] = useState([]);
//   const siteSubcompany = sessionStorage.getItem("sitemanagement_project_sub_company")

//   // const [project, setProject] = useState("null");
//   const [jsonData, setJsonData] = useState([]);
//   const [fileName, setFileName] = useState("");
//   const today = new Date();
//   const [docErrors, setDocErrors] = useState({});
//   const [docInputState, setDocInputState] = useState({});
//   today.setDate(today.getDate() - 1);
//   const year = today.getFullYear();
//   const month = today.getMonth() + 1;

//   const getCurrentMonth = () => {
//     const month = new Date().getMonth() + 1;
//     return month < 10 ? `0${month}` : `${month}`;
//   };
//   const monthNames = {
//     "01": "January", "02": "February", "03": "March", "04": "April",
//     "05": "May", "06": "June", "07": "July", "08": "August",
//     "09": "September", "10": "October", "11": "November", "12": "December"
//   };

//   const [monthh, setMonthh] = useState(getCurrentMonth);
//   const [yearr, setYearr] = useState(`${year}`);
//   const currentYear = new Date().getFullYear();
//   const startYear = currentYear - 20; // starting 20 years ago
//   const endYear = currentYear // up to 20 years in the future
//   const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);
//   const [errors, SetErrors] = useState({});

//   const [formData, setFormData] = useState({
//     project: "",
//     month: "",
//     year: "",
//     fileName: "",
//   })

//   useEffect(() => {
//     setFormData((prev) => ({
//       ...prev,
//       project: project,
//       month: monthh,
//       year: yearr,
//       fileName: fileName
//     }))
//   }, [project, yearr, monthh, fileName])


//   useEffect(() => {
//     if (formData.fileName) {
//       SetErrors((prev) => ({
//         ...prev,
//         fileName: ""
//       }))
//     }
//   }, [formData.fileName])

//   const monthOptions = [
//     { id: 1, name: "January" },
//     { id: 2, name: "February" },
//     { id: 3, name: "March" },
//     { id: 4, name: "April" },
//     { id: 5, name: "May" },
//     { id: 6, name: "June" },
//     { id: 7, name: "July" },
//     { id: 8, name: "August" },
//     { id: 9, name: "September" },
//     { id: 10, name: "October" },
//     { id: 11, name: "November" },
//     { id: 12, name: "December" }
//   ];

//   const handleShow = () => {
//     setShow(true);
//   }
//   const handleClose = () => {
//     setShow(false);
//     setProject("null");
//     setMonthh(getCurrentMonth);
//     setYearr(year);
//     setFileName("");
//     SetErrors('')
//   }
//   const getProjectData = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/siteproject/projectfiltered/`);
//       setProjectList(res.data);

//     } catch (err) {

//     }
//   };

//   useEffect(() => {
//     getProjectData();
//   }, [])



//   const getEmployee = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/siteproject/employeefilterbyproject/${project}/null/`);
//       setEmployeeData(res.data);

//     } catch (err) {

//     }
//   }
//   useEffect(() => {
//     getEmployee();
//   }, [project]);

//   const empIds = employeeList.map((item) => item.id);


//   const s2ab = (s) => {
//     const buf = new ArrayBuffer(s.length);
//     const view = new Uint8Array(buf);
//     for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
//     return buf;
//   };

//   const bulktableRef = useRef(null);
//   const handleDownload = () => {
//     const table = bulktableRef.current;
//     const wb = XLSX.utils.table_to_book(table, { sheet: "BOQ Attendance Details" });
//     const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

//     const blob = new Blob([s2ab(wbout)], {
//       type: "application/vnd.ms-excel",
//     });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = "BOQ Attendance Detail Format.xls";
//     a.click();
//     window.URL.revokeObjectURL(url);
//   };

//   const validateBeforeSubmit = () => {
//     const newErrors = {};

//     // Project validation
//     if (!formData.project || formData.project === "null" || formData.project?.toString().trim() === "") {
//       newErrors.project = "Please select Project";
//     }

//     // Month validation
//     if (!formData.month || formData.month.toString().trim() === "") {
//       newErrors.month = "Please select Month";
//     }

//     // Year validation
//     if (!formData.year || formData.year.toString().trim() === "") {
//       newErrors.year = "Please select Year";
//     }

//     // File name validation
//     if (!formData.fileName || formData.fileName.toString().trim() === "") {
//       newErrors.fileName = "Please select a file";
//     } else if (
//       !formData.fileName.endsWith(".xlsx") &&
//       !formData.fileName.endsWith(".xls")
//     ) {
//       newErrors.fileName = "Only Excel files (.xls, .xlsx) are allowed";
//     }


//     SetErrors(newErrors);

//     return Object.keys(newErrors).length === 0;
//   };





//   const checkForDuplicates = (data) => {
//     const empcodes = new Map();
//     const duplicates = [];

//     data.forEach((row, index) => {
//       const rawCode = row.emp_code;
//       const code = typeof rawCode === 'number' ? rawCode.toString() : (rawCode?.trim() || "");

//       if (!code) return;

//       if (!empcodes.has(code)) {
//         empcodes.set(code, [index + 1]);
//       } else {
//         empcodes.get(code).push(index + 1);
//       }
//     });

//     empcodes.forEach((positions, code) => {
//       if (positions.length > 1) {
//         duplicates.push(`Code: ${code} found in position(s): ${positions.join(", ")}`);
//       }
//     });

//     return duplicates;
//   };

//   const [unmatchedRows, setUnmatchedRows] = useState([]);
//   const [invalidRowIndices, setInvalidRowIndices] = useState([]);
//   const [duplicateRows, setDuplicateRows] = useState([]);
//   const [totalDayErrors, setTotalDayErrors] = useState([]);
//   const [presentDayErrors, setPresentDayErrors] = useState([]);
//   const [monthYearError, setmonthYearError] = useState([]);

//   const readExcel = (file) => {
//     const reader = new FileReader();

//     reader.onload = (e) => {
//       const data = new Uint8Array(e.target.result);
//       const workbook = XLSX.read(data, { type: "array" });

//       const sheetName = workbook.SheetNames[0];
//       const worksheet = workbook.Sheets[sheetName];
//       const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null, raw: false });

//       const headers = json[0].map(h => h?.toString().toLowerCase().trim());
//       const rows = json.slice(1);

//       const formattedJson = rows.map((row) => {
//         const obj = {};
//         headers.forEach((header, i) => {
//           let value = row[i];
//           if (header === "month") {
//             const m = parseInt(value);
//             obj["month"] = !isNaN(m) && m >= 1 && m <= 12 ? m.toString().padStart(2, "0") : null;
//           } else if (header === "year") {
//             const y = parseInt(value);
//             obj["year"] = !isNaN(y) ? (y < 100 ? `20${y.toString().padStart(2, "0")}` : y.toString()) : null;
//           } else {
//             obj[header] = value !== undefined ? value : null;
//           }
//         });
//         delete obj.project_short_name;

//         return obj;
//       });

//       const requiredFields = [
//         "emp_code", "name", "month", "year", "total_days", "present_days"
//       ];
//       const numericFields = ["month", "year", "total_days", "present_days"];

//       const cleanedJson = formattedJson.filter((row) =>
//         Object.values(row).some(val => val !== null && val.toString().trim() !== "")
//       );

//       const monthMismatchRows = cleanedJson
//         .map((row, idx) => {
//           const rowMonth = row.month?.toString().padStart(2, "0");
//           const rowYear = row.year?.toString();
//           const expectedMonth = monthh?.toString().padStart(2, "0");  // ✅ Pad here
//           const expectedYear = yearr?.toString();


//           if (rowMonth !== expectedMonth || rowYear !== expectedYear) {
//             return `${toOrdinal(idx + 1)} row → ${rowMonth}/${rowYear} ≠ ${expectedMonth}/${expectedYear}`;
//           }
//           return null;
//         })
//         .filter(Boolean);

//       const unmatchedRowsTemp = [];
//       const invalidRowIndicesTemp = [];
//       const totalDayErrors = [];
//       const presentDayErrors = [];
//       const duplicates = checkForDuplicates(formattedJson);

//       const getDaysInMonth = (month, year) => {
//         return new Date(parseInt(year), parseInt(month), 0).getDate();
//       };

//       const combinedData = cleanedJson.map((item, index) => {
//         const empCodeFromSheet = item.emp_code?.toString().trim();
//         const nameFromSheet = item.name?.toString().trim().toLowerCase();

//         const hasInvalid = numericFields.some((field) => {
//           const value = item[field];
//           return value !== null && value !== "" && isNaN(Number(value));
//         });

//         if (hasInvalid) {
//           invalidRowIndicesTemp.push(toOrdinal(index + 1));
//         }

//         const match = employeeList.find(
//           (emp) => emp.emp_code?.toString().trim() === empCodeFromSheet
//         );

//         if (!match) {
//           unmatchedRowsTemp.push(`${toOrdinal(index + 1)} row - emp_code "${item.emp_code}" not found`);
//         } else if (
//           match.name?.toString().trim().toLowerCase() !== nameFromSheet
//         ) {
//           unmatchedRowsTemp.push(`${toOrdinal(index + 1)} row - name mismatch`);
//         }

//         const rowMonth = item.month?.toString().padStart(2, "0");
//         const rowYear = item.year?.toString();
//         const totalDays = Number(item.total_days);
//         const presentDays = Number(item.present_days);

//         if (rowMonth && rowYear && !isNaN(totalDays)) {
//           const expectedDays = getDaysInMonth(rowMonth, rowYear);
//           if (totalDays !== expectedDays) {
//             totalDayErrors.push(`${toOrdinal(index + 1)} row - ${monthNames[rowMonth]} has ${expectedDays} days`);
//           }
//         }

//         if (!isNaN(presentDays) && !isNaN(totalDays) && presentDays > totalDays) {
//           presentDayErrors.push(`${toOrdinal(index + 1)} row - Present days > total days`);
//         }

//         const manMonths =
//           !isNaN(presentDays) && !isNaN(totalDays) && totalDays > 0
//             ? (presentDays / totalDays).toFixed(2)  // keep as string "0.97"
//             : null;


//         return {
//           ...item,
//           employee: match?.id || null,
//           project: project !== "null" ? project : null,
//           man_months: manMonths
//         };
//       });

//       setInvalidRowIndices(invalidRowIndicesTemp);
//       setUnmatchedRows(unmatchedRowsTemp);
//       setDuplicateRows(duplicates);
//       setmonthYearError(monthMismatchRows);
//       setTotalDayErrors(totalDayErrors);
//       setPresentDayErrors(presentDayErrors);
//       setJsonData(combinedData);
//     };

//     reader.readAsArrayBuffer(file);
//   };


//   console.log("jsonData")
//   console.log(jsonData)

//   useEffect(() => {
//     setJsonData([]);
//     setInvalidRowIndices("");
//     setUnmatchedRows("");
//     setDuplicateRows("");
//     setFileName("");
//   }, [project, monthh, yearr])


//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
//       if (!validFileTypes.includes(file.type)) {
//         setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
//         setFileName("");
//         return;
//       }


//       setFileName(file.name);
//       readExcel(file); // Convert the file to JSON
//     } else {
//       setFileName("");
//     }
//   };

//   const [loading, setLoading] = useState(false); //loading logic
//   const [uploadProgress, setUploadProgress] = useState(0);
//   const [showProgressModal, setShowProgressModal] = useState(false);
//   const handleSubmit = async (e) => {

//     e.preventDefault();


//     console.log(project, project === "null")
//     if (!validateBeforeSubmit()) return;
//     if (invalidRowIndices.length > 0) {
//       toast.warn(`⚠️ Invalid numeric data in ${invalidRowIndices.join(", ")} row`, { autoClose: 7000 });
//     }

//     if (unmatchedRows.length > 0) {
//       toast.warn(`⚠️ Mismatches found:\n${unmatchedRows.join("\n")}`, { autoClose: 7000 });
//     }

//     if (monthYearError.length > 0) {
//       toast.warn(
//         `⚠️ Month/Year mismatch in:\n${monthYearError.join("\n")}`,
//         { autoClose: 8000 }
//       );
//     }
//     if (totalDayErrors.length > 0) {
//       toast.warn(
//         `⚠️${totalDayErrors.join("\n")}`,
//         { autoClose: 8000 }
//       );
//     }
//     if (presentDayErrors.length > 0) {
//       toast.warn(
//         `⚠️${presentDayErrors.join("\n")}`,
//         { autoClose: 8000 }
//       );
//     }

//     if (duplicateRows.length > 0) {
//       toast.warn(`⚠️ Duplicate Data found:\n${duplicateRows.join("\n")}`, { autoClose: 5000 });
//     }


//     if (invalidRowIndices.length > 0 || unmatchedRows.length > 0 || duplicateRows.length > 0) {
//       return;
//     }

//     const loadingToastId = toast.loading("Loading: Please wait...");
//     setShowProgressModal(true);
//     setLoading(true);
//     setUploadProgress(0);
//     let progress = 0;
//     const interval = setInterval(() => {
//       progress += 10;
//       if (progress >= 100) {
//         progress = 100;
//         clearInterval(interval);
//       }
//       setUploadProgress(progress);
//     }, 100);
//     try {

//       const res = await axios.post(`${BASE_URL}/siteproject/attendancsitebulk/`, jsonData
//       );
//       if (res.status === 201) {
//         await getAttendance();
//         handleClose();
//         toast.dismiss(loadingToastId);
//         SetErrors('');
//         setTimeout(() => {
//           toast.dismiss(loadingToastId);
//           toast.success("Data Added successfully.");
//         }, 1000);

//       }

//     } catch (err) {
//       clearInterval(interval);
//       setUploadProgress(0);
//       handleErrorToast(err);
//       setLoading(false);
//       toast.dismiss(loadingToastId);
//     } finally {
//       clearInterval(interval);

//       setTimeout(() => {
//         setShowProgressModal(false);
//       }, 1500);

//       setLoading(false);
//       toast.dismiss(loadingToastId);
//     }
//   };





//   return (
//     <>
//       <button
//         title='Add Bulk BOQ Attendance'
//         onClick={handleShow}
//         className='upload-svg'
//       >
//         <UploadIcon />
//       </button>
//       {
//         showProgressModal ?
//           <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" /> :
//           show === true ?

//             <Modal show={show} dialogClassName='ourcompany-model'>
//               <Modal.Header className="task-Tab-heading font-weight500    font-size-heading ">
//                 <Modal.Title>Upload BOQ Bulk Attendance Data in format:</Modal.Title>
//                 {project === "null" ? <></> :
//                   <button onClick={handleDownload} className="model-button-download model-button font-weight500" style={{ marginLeft: "35vw" }}>
//                     <DownloadIcon />
//                     {"  "} Format
//                   </button>
//                 }
//               </Modal.Header>
//               <Modal.Body>
//                 <form className='register-form'>
//                   <div className="form-flex-wrap">


//                     <Projects usedFor="form" toggleProject={project} setToggleProject={setProject} value="id" subcompany={subCompany} error={errors.project} SetErrors={SetErrors} />


//                     <div title="Month" className="flex-column form-group-selectt">
//                       <label htmlFor="month" className="form-labels  font-weight500    font-size-subheading">
//                         Month<span className="required">*</span>
//                       </label>
//                       <br />
//                       <select
//                         type="text"
//                         id="month"
//                         name="month"
//                         placeholder="month"
//                         value={monthh}
//                         onChange={(e) => {
//                           setMonthh(e.target.value);
//                           if (errors.month) SetErrors((prev) => ({ ...prev, month: "" }));
//                         }}
//                         className={`form-input-date width-15vw`}
//                       >

//                         <option value="">Select a month</option>
//                         {getMonthOptionss().map((month) => (
//                           <option key={month.id} value={month.id}>{month.name}</option>
//                         ))}
//                       </select>
//                       <div>

//                         {errors.month && (
//                           <span className="error-message font-size-text ">{errors.month}</span>
//                         )}
//                       </div>

//                     </div>

//                     <div title="Year" className="flex-column form-group-selectt ">
//                       <label htmlFor="year" className="form-labels  font-weight500    font-size-subheading">
//                         Year<span className="required">*</span>
//                       </label>
//                       <br />
//                       <select
//                         type="text"
//                         id="year"
//                         name="year"
//                         placeholder="year"
//                         value={yearr}
//                         onChange={(e) => {
//                           setYearr(e.target.value);
//                           if (errors.year) SetErrors((prev) => ({ ...prev, year: "" }));
//                         }} className={`form-input-date width-10vw`}
//                       >

//                         <option value="">Select a Year</option>
//                         {years.reverse().map((year) => (
//                           <option key={year} value={year}>{year}</option>
//                         ))}
//                       </select>
//                       <div>

//                         {errors.year && (
//                           <span className="error-message font-size-text ">{errors.year}</span>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </form>



//                 <div className="table-css-white-background" style={{ display: "none" }}>
//                   <table ref={bulktableRef} className="nested-table-lightblue">
//                     <thead>
//                       <tr className="custom-table-head-tr">
//                         <th className="table-heading-text">emp_code</th>
//                         <th className="table-heading-text">name</th>
//                         <th className="table-heading-text">project_short_name</th>
//                         <th className="table-heading-text">month</th>
//                         <th className="table-heading-text">year</th>
//                         <th className="table-heading-text">total_days</th>
//                         <th className="table-heading-text">present_days</th>
//                       </tr>
//                     </thead>

//                     <tbody>
//                       {employeeList
//                         .sort((a, b) => a.emp_code - b.emp_code)
//                         .map((data, index) => (
//                           <tr key={index}>
//                             <td className="summary-excel-tab br-5">{data.emp_code}</td>
//                             <td className="summary-excel-tab br-5">{data.name}</td>
//                             <td className="summary-excel-tab br-5">
//                               {Array.isArray(projectList)
//                                 ? projectList.find(p => p.id === project)?.project_short_name || "-"
//                                 : "-"}
//                             </td>

//                             <td className="summary-excel-tab br-5 text-center">{monthh}</td>
//                             <td className="summary-excel-tab br-5 text-center">{yearr}</td>
//                             <td className="summary-excel-tab br-5 text-center">{"-"}</td>
//                             <td className="summary-excel-tab br-5 text-center">{"-"}</td>
//                           </tr>
//                         ))}
//                     </tbody>
//                   </table>
//                 </div>

//                 {
//                   fileName !== "" &&
//                   <div className="table-css-white-background scroll-container" style={{ zIndex: "0" }}
//                   >
//                     <div className="table-container scrollbar" style={{ width: "100%" }}>
//                       <table className="nested-table-lightblue" style={{ margin: "0px" }}>
//                         <thead className="table-heading">
//                           <tr className="custom-table-head-tr modal-padding-heading">
//                             <th className="table-heading-text">S.no.</th>
//                             <th className="table-heading-text">emp_code</th>
//                             <th className="table-heading-text">name</th>
//                             <th className="table-heading-text">project_short_name</th>

//                             <th className="table-heading-text">month</th>
//                             <th className="table-heading-text">year</th>
//                             <th className="table-heading-text">total_days</th>
//                             <th className="table-heading-text">present_days</th>
//                             <th className="table-heading-text">man_months</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {jsonData
//                             .map((data, index) => {


//                               const inactivename = data.employee_status === "inactive" ? "#ff1212" : "black";


//                               return (
//                                 <>
//                                   <tr key={index} className="modal-padding-heading">

//                                     <td className="table-heading-text">{index + 1}.</td>
//                                     <td className="table-heading-text">{data.emp_code}</td>
//                                     <td className="table-heading-text">{data.name}</td>
//                                     <td className="summary-excel-tab br-5">
//                                       {Array.isArray(projectList)
//                                         ? projectList.find(p => p.id === project)?.project_short_name || "-"
//                                         : "-"}
//                                     </td>

//                                     <td className="table-heading-text table-heading-text">{data.month}</td>
//                                     <td className="table-heading-text table-heading-text">{data.year}</td>
//                                     <td className="table-heading-text table-heading-text">{data.total_days}</td>
//                                     <td className="table-heading-text table-heading-text">{data.present_days}</td>
//                                     <td className="table-heading-text table-heading-text">{data.man_months}</td>
//                                   </tr>
//                                 </>
//                               );
//                             })}
//                         </tbody>
//                       </table >
//                     </div>
//                   </div>
//                 }


//                 <div className="flex-column field-cont-div">
//                   <label htmlFor="document_file" className="form-labels font-weight500 font-size-heading" title="Upload Bulk Attendance">
//                     Upload File
//                   </label>
//                   <label
//                     htmlFor="document_file"
//                     className={`custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
//                       }`}
//                   >
//                     <div className={`align-center pdf-input  ${errors.fileName ? 'error' : ''}`}>
//                       <Attachment />
//                     </div>
//                   </label>
//                   <input
//                     type="file"
//                     accept=".xlsx, .xls"
//                     onChange={handleFileChange}
//                     id="document_file"
//                     name="document_file"
//                     className="file-inputs align-center"
//                     style={{ display: "none", position: "relative" }} />
//                   {fileName && <p className="file-name align-center">{fileName}</p>}
//                   <br />
//                   {errors.fileName && <span className="file-name error-message font-size-text ">{errors.fileName}</span>}
//                 </div>
//                 <div className="button-models">
//                   <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
//                     Cancel
//                   </button>
//                   <button className="model-button-download model-button font-weight500" onClick={handleSubmit}>
//                     <UploadIcon />
//                     {"  "} Upload
//                   </button>
//                 </div>
//                 <ToastContainer
//                   position="top-center"
//                   autoClose={1000}
//                   hideProgressBar={false}
//                   newestOnTop={true}
//                   closeOnClick
//                   rtl={false}
//                   pauseOnFocusLoss
//                   draggable
//                   pauseOnHover
//                 />
//               </Modal.Body>
//             </Modal > : ""
//       }


//     </>
//   )
// }


// const AddBulkboqAttendance = ({ getAttendance, i, project, setProject, subCompany }) => {
//   const [formatLoading, setFormatLoading] = useState(false);
//   const [show, setShow] = useState(false);
//   const [projectList, setProjectList] = useState([]);
//   const [employeeList, setEmployeeData] = useState([]);
//   const siteSubcompany = sessionStorage.getItem("sitemanagement_project_sub_company")

//   const [jsonData, setJsonData] = useState([]);
//   const [fileName, setFileName] = useState("");
//   const [fileSize, setFileSize] = useState("");
//   const [isDragging, setIsDragging] = useState(false);
//   const today = new Date();
//   const [docErrors, setDocErrors] = useState({});
//   const [docInputState, setDocInputState] = useState({});
//   today.setDate(today.getDate() - 1);
//   const year = today.getFullYear();

//   const fileInputRef = useRef(null);

//   const getCurrentMonth = () => {
//     const month = new Date().getMonth() + 1;
//     return month < 10 ? `0${month}` : `${month}`;
//   };
//   const monthNames = {
//     "01": "January", "02": "February", "03": "March", "04": "April",
//     "05": "May", "06": "June", "07": "July", "08": "August",
//     "09": "September", "10": "October", "11": "November", "12": "December"
//   };

//   const [monthh, setMonthh] = useState(getCurrentMonth);
//   const [yearr, setYearr] = useState(`${year}`);
//   const currentYear = new Date().getFullYear();
//   const startYear = currentYear - 20;
//   const endYear = currentYear + 20;
//   const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);
//   const [errors, SetErrors] = useState({});

//   const [formData, setFormData] = useState({
//     project: "",
//     month: "",
//     year: "",
//     fileName: "",
//   })

//   useEffect(() => {
//     setFormData((prev) => ({
//       ...prev,
//       project: project,
//       month: monthh,
//       year: yearr,
//       fileName: fileName
//     }))
//   }, [project, yearr, monthh, fileName])


//   useEffect(() => {
//     if (formData.fileName) {
//       SetErrors((prev) => ({
//         ...prev,
//         fileName: ""
//       }))
//     }
//   }, [formData.fileName])

//   const formatFileSize = (bytes) => {
//     if (bytes < 1024) return `${bytes} B`;
//     if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
//     return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
//   };

//   const handleShow = () => {
//     setShow(true);
//   }
//   const handleClose = () => {
//     setShow(false);
//     setProject("null");
//     setMonthh(getCurrentMonth);
//     setYearr(year);
//     setFileName("");
//     setFileSize("");
//     setDocErrors({});
//     setDocInputState({});
//     SetErrors('')
//   }
//   const getProjectData = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/siteproject/projectfiltered/`);
//       setProjectList(res.data);

//     } catch (err) {

//     }
//   };

//   useEffect(() => {
//     getProjectData();
//   }, [])



//   const getEmployee = async () => {
//     if (project === "null") return;

//     try {
//       setFormatLoading(true);

//       const res = await axios.get(
//         `${BASE_URL}/siteproject/employeefilterbyproject/${project}/null/`
//       );

//       setEmployeeData(res.data);
//     } catch (err) {
//       console.log(err);
//     } finally {
//       setFormatLoading(false);
//     }
//   };
//   useEffect(() => {
//     getEmployee();
//   }, [project]);

//   const empIds = employeeList.map((item) => item.id);


//   const s2ab = (s) => {
//     const buf = new ArrayBuffer(s.length);
//     const view = new Uint8Array(buf);
//     for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
//     return buf;
//   };

//   const bulktableRef = useRef(null);
//   const handleDownload = () => {
//     const table = bulktableRef.current;
//     const wb = XLSX.utils.table_to_book(table, { sheet: "BOQ Attendance Details" });
//     const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

//     const blob = new Blob([s2ab(wbout)], {
//       type: "application/vnd.ms-excel",
//     });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = "BOQ Attendance Detail Format.xls";
//     a.click();
//     window.URL.revokeObjectURL(url);
//   };

//   const validateBeforeSubmit = () => {
//     const newErrors = {};

//     // Project validation
//     if (!formData.project || formData.project === "null" || formData.project?.toString().trim() === "") {
//       newErrors.project = "Please select Project";
//     }

//     // Month validation
//     if (!formData.month || formData.month.toString().trim() === "") {
//       newErrors.month = "Please select Month";
//     }

//     // Year validation
//     if (!formData.year || formData.year.toString().trim() === "") {
//       newErrors.year = "Please select Year";
//     }

//     // File name validation
//     if (!formData.fileName || formData.fileName.toString().trim() === "") {
//       newErrors.fileName = "Please select a file";
//     } else if (
//       !formData.fileName.endsWith(".xlsx") &&
//       !formData.fileName.endsWith(".xls")
//     ) {
//       newErrors.fileName = "Only Excel files (.xls, .xlsx) are allowed";
//     }


//     SetErrors(newErrors);

//     return Object.keys(newErrors).length === 0;
//   };


//   const checkForDuplicates = (data) => {
//     const empcodes = new Map();
//     const duplicates = [];

//     data.forEach((row, index) => {
//       const rawCode = row.emp_code;
//       const code = typeof rawCode === 'number' ? rawCode.toString() : (rawCode?.trim() || "");

//       if (!code) return;

//       if (!empcodes.has(code)) {
//         empcodes.set(code, [index + 1]);
//       } else {
//         empcodes.get(code).push(index + 1);
//       }
//     });

//     empcodes.forEach((positions, code) => {
//       if (positions.length > 1) {
//         duplicates.push(`Code: ${code} found in position(s): ${positions.join(", ")}`);
//       }
//     });

//     return duplicates;
//   };

//   const [unmatchedRows, setUnmatchedRows] = useState([]);
//   const [invalidRowIndices, setInvalidRowIndices] = useState([]);
//   const [duplicateRows, setDuplicateRows] = useState([]);
//   const [totalDayErrors, setTotalDayErrors] = useState([]);
//   const [presentDayErrors, setPresentDayErrors] = useState([]);
//   const [monthYearError, setmonthYearError] = useState([]);

//   const readExcel = (file) => {
//     const reader = new FileReader();

//     reader.onload = (e) => {
//       const data = new Uint8Array(e.target.result);
//       const workbook = XLSX.read(data, { type: "array" });

//       const sheetName = workbook.SheetNames[0];
//       const worksheet = workbook.Sheets[sheetName];
//       const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null, raw: false });

//       const headers = json[0].map(h => h?.toString().toLowerCase().trim());
//       const rows = json.slice(1);

//       const formattedJson = rows.map((row) => {
//         const obj = {};
//         headers.forEach((header, i) => {
//           let value = row[i];
//           if (header === "month") {
//             const m = parseInt(value);
//             obj["month"] = !isNaN(m) && m >= 1 && m <= 12 ? m.toString().padStart(2, "0") : null;
//           } else if (header === "year") {
//             const y = parseInt(value);
//             obj["year"] = !isNaN(y) ? (y < 100 ? `20${y.toString().padStart(2, "0")}` : y.toString()) : null;
//           } else {
//             obj[header] = value !== undefined ? value : null;
//           }
//         });
//         delete obj.project_short_name;

//         return obj;
//       });

//       const requiredFields = [
//         "emp_code", "name", "month", "year", "total_days", "present_days"
//       ];
//       const numericFields = ["month", "year", "total_days", "present_days"];

//       const cleanedJson = formattedJson.filter((row) =>
//         Object.values(row).some(val => val !== null && val.toString().trim() !== "")
//       );

//       const monthMismatchRows = cleanedJson
//         .map((row, idx) => {
//           const rowMonth = row.month?.toString().padStart(2, "0");
//           const rowYear = row.year?.toString();
//           const expectedMonth = monthh?.toString().padStart(2, "0");  // ✅ Pad here
//           const expectedYear = yearr?.toString();


//           if (rowMonth !== expectedMonth || rowYear !== expectedYear) {
//             return `${toOrdinal(idx + 1)} row → ${rowMonth}/${rowYear} ≠ ${expectedMonth}/${expectedYear}`;
//           }
//           return null;
//         })
//         .filter(Boolean);

//       const unmatchedRowsTemp = [];
//       const invalidRowIndicesTemp = [];
//       const totalDayErrors = [];
//       const presentDayErrors = [];
//       const duplicates = checkForDuplicates(formattedJson);

//       const getDaysInMonth = (month, year) => {
//         return new Date(parseInt(year), parseInt(month), 0).getDate();
//       };

//       const combinedData = cleanedJson.map((item, index) => {
//         const empCodeFromSheet = item.emp_code?.toString().trim();
//         const nameFromSheet = item.name?.toString().trim().toLowerCase();

//         const hasInvalid = numericFields.some((field) => {
//           const value = item[field];
//           return value !== null && value !== "" && isNaN(Number(value));
//         });

//         if (hasInvalid) {
//           invalidRowIndicesTemp.push(toOrdinal(index + 1));
//         }

//         const match = employeeList.find(
//           (emp) => emp.emp_code?.toString().trim() === empCodeFromSheet
//         );

//         if (!match) {
//           unmatchedRowsTemp.push(`${toOrdinal(index + 1)} row - emp_code "${item.emp_code}" not found`);
//         } else if (
//           match.name?.toString().trim().toLowerCase() !== nameFromSheet
//         ) {
//           unmatchedRowsTemp.push(`${toOrdinal(index + 1)} row - name mismatch`);
//         }

//         const rowMonth = item.month?.toString().padStart(2, "0");
//         const rowYear = item.year?.toString();
//         const totalDays = Number(item.total_days);
//         const presentDays = Number(item.present_days);

//         if (rowMonth && rowYear && !isNaN(totalDays)) {
//           const expectedDays = getDaysInMonth(rowMonth, rowYear);
//           if (totalDays !== expectedDays) {
//             totalDayErrors.push(`${toOrdinal(index + 1)} row - ${monthNames[rowMonth]} has ${expectedDays} days`);
//           }
//         }

//         if (!isNaN(presentDays) && !isNaN(totalDays) && presentDays > totalDays) {
//           presentDayErrors.push(`${toOrdinal(index + 1)} row - Present days > total days`);
//         }

//         const manMonths =
//           !isNaN(presentDays) && !isNaN(totalDays) && totalDays > 0
//             ? (presentDays / totalDays).toFixed(2)  // keep as string "0.97"
//             : null;


//         return {
//           ...item,
//           employee: match?.id || null,
//           project: project !== "null" ? project : null,
//           man_months: manMonths
//         };
//       });

//       setInvalidRowIndices(invalidRowIndicesTemp);
//       setUnmatchedRows(unmatchedRowsTemp);
//       setDuplicateRows(duplicates);
//       setmonthYearError(monthMismatchRows);
//       setTotalDayErrors(totalDayErrors);
//       setPresentDayErrors(presentDayErrors);
//       setJsonData(combinedData);
//     };

//     reader.readAsArrayBuffer(file);
//   };

//   useEffect(() => {
//     setJsonData([]);
//     setInvalidRowIndices("");
//     setUnmatchedRows("");
//     setDuplicateRows("");
//     setFileName("");
//     setFileSize("");
//   }, [project, monthh, yearr])

//   // ---- Unified file handling (validate -> set state -> parse) ----
//   const processFile = (file) => {
//     if (!file) return;
//     const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
//     if (!validFileTypes.includes(file.type)) {
//       setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
//       setFileName("");
//       setFileSize("");
//       return;
//     }

//     setFileName(file.name);
//     setFileSize(formatFileSize(file.size));
//     setDocErrors({});
//     setDocInputState({ document_file: "green" });
//     readExcel(file);
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     processFile(file);
//   };

//   const handleRemoveFile = () => {
//     setFileName("");
//     setFileSize("");
//     setJsonData([]);
//     setInvalidRowIndices([]);
//     setUnmatchedRows([]);
//     setDuplicateRows([]);
//     setTotalDayErrors([]);
//     setPresentDayErrors([]);
//     setmonthYearError([]);
//     setDocErrors({});
//     setDocInputState({});
//     if (fileInputRef.current) fileInputRef.current.value = "";
//   };

//   const handleDragOver = (e) => {
//     e.preventDefault();
//     setIsDragging(true);
//   };

//   const handleDragLeave = (e) => {
//     e.preventDefault();
//     setIsDragging(false);
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     setIsDragging(false);
//     const file = e.dataTransfer.files[0];
//     processFile(file);
//   };

//   const [loading, setLoading] = useState(false); //loading logic
//   const [uploadProgress, setUploadProgress] = useState(0);
//   const [showProgressModal, setShowProgressModal] = useState(false);
//   const handleSubmit = async (e) => {

//     e.preventDefault();

//     if (!validateBeforeSubmit()) return;
//     if (invalidRowIndices.length > 0) {
//       toast.warn(`⚠️ Invalid numeric data in ${invalidRowIndices.join(", ")} row`, { autoClose: 7000 });
//     }

//     if (unmatchedRows.length > 0) {
//       toast.warn(`⚠️ Mismatches found:\n${unmatchedRows.join("\n")}`, { autoClose: 7000 });
//     }

//     if (monthYearError.length > 0) {
//       toast.warn(
//         `⚠️ Month/Year mismatch in:\n${monthYearError.join("\n")}`,
//         { autoClose: 8000 }
//       );
//     }
//     if (totalDayErrors.length > 0) {
//       toast.warn(
//         `⚠️${totalDayErrors.join("\n")}`,
//         { autoClose: 8000 }
//       );
//     }
//     if (presentDayErrors.length > 0) {
//       toast.warn(
//         `⚠️${presentDayErrors.join("\n")}`,
//         { autoClose: 8000 }
//       );
//     }

//     if (duplicateRows.length > 0) {
//       toast.warn(`⚠️ Duplicate Data found:\n${duplicateRows.join("\n")}`, { autoClose: 5000 });
//     }


//     if (invalidRowIndices.length > 0 || unmatchedRows.length > 0 || duplicateRows.length > 0) {
//       return;
//     }

//     const loadingToastId = toast.loading("Loading: Please wait...");
//     setShowProgressModal(true);
//     setLoading(true);
//     setUploadProgress(0);
//     let progress = 0;
//     const interval = setInterval(() => {
//       progress += 10;
//       if (progress >= 100) {
//         progress = 100;
//         clearInterval(interval);
//       }
//       setUploadProgress(progress);
//     }, 100);
//     try {

//       const res = await axios.post(`${BASE_URL}/siteproject/attendancsitebulk/`, jsonData
//       );
//       if (res.status === 201) {
//         await getAttendance();
//         handleClose();
//         toast.dismiss(loadingToastId);
//         SetErrors('');
//         setTimeout(() => {
//           toast.dismiss(loadingToastId);
//           toast.success("Data Added successfully.");
//         }, 1000);

//       }

//     } catch (err) {
//       clearInterval(interval);
//       setUploadProgress(0);
//       handleErrorToast(err);
//       setLoading(false);
//       toast.dismiss(loadingToastId);
//     } finally {
//       clearInterval(interval);

//       setTimeout(() => {
//         setShowProgressModal(false);
//       }, 1500);

//       setLoading(false);
//       toast.dismiss(loadingToastId);
//     }
//   };

//   // Add these two option arrays near your other option builders (e.g. near `years`)
//   const monthOptions = Object.entries(monthNames).map(([value, label]) => ({
//     value,
//     label,
//   }));

//   const yearOptions = years.map((y) => ({ value: `${y}`, label: `${y}` }));
//   return (
//     <>
//       <style>{`
//         .ub-upload-zone {
//           border: 2px dashed #c7cdd6;
//           border-radius: 14px;
//           background: #fafbfd;
//           padding: 32px 20px;
//           text-align: center;
//           cursor: pointer;
//           transition: all 0.2s ease;
//           position: relative;
//         }
//         .ub-upload-zone:hover {
//           border-color: #6366f1;
//           background: #f5f5ff;
//         }
//         .ub-upload-zone.dragging {
//           border-color: #6366f1;
//           background: #eef0ff;
//           transform: scale(1.01);
//         }
//         .ub-upload-zone.has-error {
//           border-color: #e11d48;
//           background: #fff1f2;
//         }
//         .ub-upload-zone.disabled {
//           cursor: not-allowed;
//           opacity: 0.55;
//         }
//         .ub-upload-icon-circle {
//           width: 56px;
//           height: 56px;
//           border-radius: 50%;
//           background: linear-gradient(135deg, #6366f1, #8b5cf6);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           margin: 0 auto 14px;
//           color: white;
//           box-shadow: 0 4px 14px rgba(99, 102, 241, 0.3);
//         }
//         .ub-upload-title {
//           font-size: 15px;
//           font-weight: 600;
//           color: #1f2937;
//           margin: 0 0 4px;
//         }
//         .ub-upload-subtitle {
//           font-size: 13px;
//           color: #6b7280;
//           margin: 0;
//         }
//         .ub-upload-browse {
//           color: #6366f1;
//           font-weight: 600;
//           text-decoration: underline;
//         }
//         .ub-file-card {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           background: #f0fdf4;
//           border: 1px solid #bbf7d0;
//           border-radius: 12px;
//           padding: 14px 16px;
//           margin-top: 12px;
//           animation: ub-fade-in 0.25s ease;
//         }
//         .ub-file-icon {
//           width: 40px;
//           height: 40px;
//           border-radius: 10px;
//           background: #16a34a;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: white;
//           flex-shrink: 0;
//         }
//         .ub-file-info {
//           flex: 1;
//           min-width: 0;
//         }
//         .ub-file-name {
//           font-size: 14px;
//           font-weight: 600;
//           color: #1f2937;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }
//         .ub-file-size {
//           font-size: 12px;
//           color: #6b7280;
//         }
//         .ub-file-remove {
//           background: none;
//           border: none;
//           cursor: pointer;
//           color: #9ca3af;
//           padding: 6px;
//           border-radius: 8px;
//           display: flex;
//           transition: all 0.15s ease;
//           flex-shrink: 0;
//         }
//         .ub-file-remove:hover {
//           background: #fee2e2;
//           color: #dc2626;
//         }
//         @keyframes ub-fade-in {
//           from { opacity: 0; transform: translateY(-4px); }
//           to { opacity: 1; transform: translateY(0); }
//         }
//         .ub-preview-wrap {
//           border: 1px solid #e5e7eb;
//           border-radius: 14px;
//           overflow: hidden;
//           margin-top: 8px;
//         }
//         .ub-preview-scroll {
//           overflow-x: auto;
//           max-height: 340px;
//           overflow-y: auto;
//         }
//         .ub-preview-table {
//           width: 100%;
//           border-collapse: collapse;
//           font-size: 13px;
//           white-space: nowrap;
//         }
//         .ub-preview-table thead th {
//           position: sticky;
//           top: 0;
//           background: #f8fafc;
//           color: #475569;
//           font-weight: 600;
//           text-align: left;
//           padding: 10px 14px;
//           border-bottom: 2px solid #e2e8f0;
//           z-index: 1;
//         }
//         .ub-preview-table tbody td {
//           padding: 9px 14px;
//           color: #334155;
//           border-bottom: 1px solid #f1f5f9;
//         }
//         .ub-preview-table tbody tr:nth-child(even) {
//           background: #fbfcfe;
//         }
//         .ub-preview-table tbody tr:hover {
//           background: #f0f4ff;
//         }
//         .ub-preview-header {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           padding: 10px 4px;
//         }
//         .ub-preview-badge {
//           background: #eef2ff;
//           color: #4338ca;
//           font-size: 12px;
//           font-weight: 600;
//           padding: 4px 10px;
//           border-radius: 999px;
//         }
//         .ub-download-row {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           background: #f8fafc;
//           border: 1px solid #e5e7eb;
//           border-radius: 12px;
//           padding: 14px 16px;
//           margin-bottom: 18px;
//           gap: 12px;
//         }
//         .ub-download-row p {
//           margin: 0;
//           font-size: 13.5px;
//           color: #475569;
//         }
//         .ub-warning-banner {
//           display: flex;
//           align-items: flex-start;
//           gap: 10px;
//           background: #fffbeb;
//           border: 1px solid #fde68a;
//           color: #92400e;
//           border-radius: 10px;
//           padding: 10px 14px;
//           margin-top: 10px;
//           font-size: 13px;
//           white-space: pre-line;
//         }
//       `}</style>

//       <button
//         title="Upload BOQ Bulk Attendance"
//         className="btn-animated"
//         onClick={handleShow}
//         style={{ margin: "2px" }}
//       >
//         <UploadIcon /> Bulk BOQ Attendance
//       </button>

//       {showProgressModal ? (
//         <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" />
//       ) : show === true ? (
//         <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal model-width80vw" size="xl">
//           <Modal.Header className="modern-modal-header">
//             <div className="header-content">
//               <div style={{ color: "white" }}>
//                 <UploadIcon />
//               </div>
//               <div>
//                 <Modal.Title>Upload BOQ Bulk Attendance Data</Modal.Title>
//                 <p className="header-subtitle" style={{ color: "white" }}>Select project, month & year, then upload the Excel format</p>
//               </div>
//             </div>
//             <button className="close-btn" onClick={handleClose}>
//               <X size={20} />
//             </button>
//           </Modal.Header>

//           <Modal.Body className="modern-modal-body">

//             {project !== "null" && (
//               <div className="ub-download-row">
//                 <p>
//                   Download the Excel template for the selected employees.
//                 </p>

//                 {formatLoading ? (
//                   <button className="btn-primaryy" disabled>
//                     <Spinner
//                       animation="border"
//                       size="sm"
//                       style={{ marginRight: 8 }}
//                     />
//                     Loading...
//                   </button>
//                 ) : (
//                   <button
//                     onClick={handleDownload}
//                     className="btn-primaryy"
//                     disabled={!employeeList.length}
//                   >
//                     <DownloadIcon />
//                     Format
//                   </button>
//                 )}
//               </div>
//             )}

//             <div className="section-title">
//               <h4>Attendance Details</h4>
//             </div>

//             <div className="form-grid">
//               {sessionStorage.getItem("sitemanagement_role") !== "SiteManagement" && (
//                 <Projects cssType="modern" usedFor="form" toggleProject={project} setToggleProject={setProject} value="id" subcompany={subCompany} error={errors.project} SetErrors={SetErrors} />
//               )}
//               <div title="Month" className="form-field">
//                 <label>
//                   <Calendar size={14} /> Month<span className="required">*</span>
//                 </label>
//                 <Select
//                   options={monthOptions}
//                   isSearchable
//                   placeholder="Select a Month"
//                   value={monthOptions.find((opt) => opt.value === monthh) || null}
//                   onChange={(selected) => {
//                     setMonthh(selected ? selected.value : "");
//                     if (errors.month) SetErrors((prev) => ({ ...prev, month: "" }));
//                   }}
//                   styles={CSSForSelectModern}
//                 />
//                 {errors.month && (
//                   <span className="error-message font-size-text">{errors.month}</span>
//                 )}
//               </div>

//               <div title="Year" className="form-field">
//                 <label>
//                   <Calendar size={14} /> Year<span className="required">*</span>
//                 </label>
//                 <Select
//                   options={yearOptions}
//                   isSearchable
//                   placeholder="Select a Year"
//                   value={yearOptions.find((opt) => opt.value === yearr) || null}
//                   onChange={(selected) => {
//                     setYearr(selected ? selected.value : "");
//                     if (errors.year) SetErrors((prev) => ({ ...prev, year: "" }));
//                   }}
//                   styles={CSSForSelectModern}
//                 />
//                 {errors.year && (
//                   <span className="error-message font-size-text">{errors.year}</span>
//                 )}
//               </div>
//             </div>

//             {/* Hidden table used only as the source for the downloadable format */}
//             <div className="table-css-white-background" style={{ display: "none" }}>
//               <table ref={bulktableRef} className="nested-table-lightblue">
//                 <thead>
//                   <tr className="custom-table-head-tr">
//                     <th className="table-heading-text">emp_code</th>
//                     <th className="table-heading-text">name</th>
//                     <th className="table-heading-text">project_short_name</th>
//                     <th className="table-heading-text">month</th>
//                     <th className="table-heading-text">year</th>
//                     <th className="table-heading-text">total_days</th>
//                     <th className="table-heading-text">present_days</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {employeeList
//                     .sort((a, b) => a.emp_code - b.emp_code)
//                     .map((data, index) => (
//                       <tr key={index}>
//                         <td className="summary-excel-tab br-5">{data.emp_code}</td>
//                         <td className="summary-excel-tab br-5">{data.name}</td>
//                         <td className="summary-excel-tab br-5">
//                           {Array.isArray(projectList)
//                             ? projectList.find(p => p.id === project)?.project_short_name || "-"
//                             : "-"}
//                         </td>

//                         <td className="summary-excel-tab br-5 text-center">{monthh}</td>
//                         <td className="summary-excel-tab br-5 text-center">{yearr}</td>
//                         <td className="summary-excel-tab br-5 text-center">{"-"}</td>
//                         <td className="summary-excel-tab br-5 text-center">{"-"}</td>
//                       </tr>
//                     ))}
//                 </tbody>
//               </table>
//             </div>

//             <div className="section-title">
//               <h4>Upload File</h4>
//             </div>

//             <div
//               className={`ub-upload-zone ${isDragging ? 'dragging' : ''} ${docErrors.document_file ? 'has-error' : ''} ${project === "null" ? 'disabled' : ''}`}
//               onDragOver={project === "null" ? undefined : handleDragOver}
//               onDragLeave={project === "null" ? undefined : handleDragLeave}
//               onDrop={project === "null" ? undefined : handleDrop}
//               onClick={() => project !== "null" && fileInputRef.current?.click()}
//             >
//               <div className="ub-upload-icon-circle">
//                 <Attachment />
//               </div>
//               <p className="ub-upload-title">
//                 {project === "null" ? "Select a project first" : "Drag & drop your Excel file here"}
//               </p>
//               <p className="ub-upload-subtitle">
//                 {project === "null"
//                   ? "The upload area unlocks once a project is chosen"
//                   : <>or <span className="ub-upload-browse">browse</span> to choose a file &nbsp;·&nbsp; .xlsx or .xls</>}
//               </p>
//               <input
//                 ref={fileInputRef}
//                 id="document_file"
//                 name="document_file"
//                 type="file"
//                 accept=".xlsx, .xls"
//                 onChange={handleFileChange}
//                 disabled={project === "null"}
//                 style={{ display: "none" }}
//               />
//             </div>

//             {docErrors.document_file && (
//               <div className="tab-error-message" style={{ marginTop: '10px' }}>
//                 <AlertCircle size={14} />
//                 <span>{docErrors.document_file}</span>
//               </div>
//             )}
//             {errors.fileName && !docErrors.document_file && (
//               <div className="tab-error-message" style={{ marginTop: '10px' }}>
//                 <AlertCircle size={14} />
//                 <span>{errors.fileName}</span>
//               </div>
//             )}

//             {fileName && !docErrors.document_file && (
//               <div className="ub-file-card">
//                 <div className="ub-file-icon">
//                   <FileText size={20} />
//                 </div>
//                 <div className="ub-file-info">
//                   <div className="ub-file-name">{fileName}</div>
//                   <div className="ub-file-size">{fileSize}{jsonData?.length ? ` · ${jsonData.length} records found` : ''}</div>
//                 </div>
//                 <button type="button" className="ub-file-remove" onClick={handleRemoveFile} title="Remove file">
//                   <X size={18} />
//                 </button>
//               </div>
//             )}

//             {(invalidRowIndices.length > 0 || unmatchedRows.length > 0 || duplicateRows.length > 0 ||
//               monthYearError.length > 0 || totalDayErrors.length > 0 || presentDayErrors.length > 0) && (
//                 <div className="ub-warning-banner">
//                   <AlertCircle size={16} style={{ flexShrink: 0, marginTop: 1 }} />
//                   <div>
//                     {invalidRowIndices.length > 0 && <div>Invalid numeric data in {invalidRowIndices.join(", ")} row</div>}
//                     {unmatchedRows.length > 0 && <div>{unmatchedRows.join("\n")}</div>}
//                     {monthYearError.length > 0 && <div>{monthYearError.join("\n")}</div>}
//                     {totalDayErrors.length > 0 && <div>{totalDayErrors.join("\n")}</div>}
//                     {presentDayErrors.length > 0 && <div>{presentDayErrors.join("\n")}</div>}
//                     {duplicateRows.length > 0 && <div>{duplicateRows.join("\n")}</div>}
//                   </div>
//                 </div>
//               )}

//             {fileName !== "" && jsonData.length > 0 && (
//               <>
//                 <div className="ub-preview-header">
//                   <div className="section-title" style={{ marginBottom: 0 }}>
//                     <h4 style={{ margin: 0 }}>Preview</h4>
//                   </div>
//                   <span className="ub-preview-badge">{jsonData.length} records</span>
//                 </div>

//                 <div className="ub-preview-wrap">
//                   <div className="ub-preview-scroll table-box scroll-container-table">
//                     <table className="ub-preview-table">
//                       <thead className="table-heading">
//                         <tr>
//                           <th>S.no.</th>
//                           <th>Emp Code</th>
//                           <th>Name</th>
//                           <th>Project</th>
//                           <th>Month</th>
//                           <th>Year</th>
//                           <th>Total Days</th>
//                           <th>Present Days</th>
//                           <th>Man Months</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {jsonData.map((data, index) => (
//                           <tr key={index}>
//                             <td>{index + 1}.</td>
//                             <td>{data.emp_code}</td>
//                             <td>{data.name}</td>
//                             <td>
//                               {Array.isArray(projectList)
//                                 ? projectList.find(p => p.id === project)?.project_short_name || "-"
//                                 : "-"}
//                             </td>
//                             <td>{data.month}</td>
//                             <td>{data.year}</td>
//                             <td>{data.total_days}</td>
//                             <td>{data.present_days}</td>
//                             <td>{data.man_months}</td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </>
//             )}

//             <div className="form-actions">
//               <button type="button" className="btn-secondaryy" onClick={handleClose}>
//                 Cancel
//               </button>
//               <button type="button" className="btn-primaryy" onClick={handleSubmit} disabled={!fileName}>
//                 <UploadIcon />
//                 <span>Upload</span>
//               </button>
//             </div>

//             <ToastContainer
//               position="top-center"
//               autoClose={1000}
//               hideProgressBar={false}
//               newestOnTop={true}
//               closeOnClick
//               rtl={false}
//               pauseOnFocusLoss
//               draggable
//               pauseOnHover
//             />
//           </Modal.Body>
//         </Modal>
//       ) : ""}
//     </>
//   )
// };


const AddBulkboqAttendance = ({ getAttendance, i, project, setProject, subCompany }) => {
  const [formatLoading, setFormatLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [mergedProjects, setMergedProjects] = useState([]);
  const [employeeList, setEmployeeData] = useState([]);
  const siteSubcompany = sessionStorage.getItem("sitemanagement_project_sub_company")

  const [jsonData, setJsonData] = useState([]);
  const [fileName, setFileName] = useState("");
  const [fileSize, setFileSize] = useState("");
  const [isDragging, setIsDragging] = useState(false);
  const today = new Date();
  const [docErrors, setDocErrors] = useState({});
  const [docInputState, setDocInputState] = useState({});
  today.setDate(today.getDate() - 1);
  const year = today.getFullYear();

  const fileInputRef = useRef(null);

  const getCurrentMonth = () => {
    const month = new Date().getMonth() + 1;
    return month < 10 ? `0${month}` : `${month}`;
  };
  const monthNames = {
    "01": "January", "02": "February", "03": "March", "04": "April",
    "05": "May", "06": "June", "07": "July", "08": "August",
    "09": "September", "10": "October", "11": "November", "12": "December"
  };

  const [monthh, setMonthh] = useState(getCurrentMonth);
  const [yearr, setYearr] = useState(`${year}`);
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 20;
  const endYear = currentYear + 20;
  const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);
  const [errors, SetErrors] = useState({});

  const [formData, setFormData] = useState({
    project: "",
    month: "",
    year: "",
    fileName: "",
  })

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      project: project,
      month: monthh,
      year: yearr,
      fileName: fileName
    }))
  }, [project, yearr, monthh, fileName])


  useEffect(() => {
    if (formData.fileName) {
      SetErrors((prev) => ({
        ...prev,
        fileName: ""
      }))
    }
  }, [formData.fileName])

  const formatFileSize = (bytes) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  const handleShow = () => {
    setShow(true);
  }
  const handleClose = () => {
    setShow(false);
    setProject("null");
    setMonthh(getCurrentMonth);
    setYearr(year);
    setFileName("");
    setFileSize("");
    setDocErrors({});
    setDocInputState({});
    SetErrors('')
  }



  const getProjectData = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/null/null/null/null/`
      );
      setProjectList(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getProjectData();
  }, [])


  const getEmployee = async () => {
    if (project === "null") {
      setEmployeeData([]);
      return;
    }

    try {
      setFormatLoading(true);

      const [res1, res2] = await Promise.all([
        axios.get(`${BASE_URL}/siteproject/employeefilterbyproject/${project}/null/`),
        axios.get(`${BASE_URL}/siteproject/employeemultipleproject/${project}/`),
      ]);

      const list1 = Array.isArray(res1.data) ? res1.data : [];
      const list2 = Array.isArray(res2.data) ? res2.data : [];

      // Merge: same employee (id) ho to fields combine, warna add
      const map = new Map();
      [...list1, ...list2].forEach((emp) => {
        const key = emp.id ?? emp.emp_code;
        map.set(key, { ...map.get(key), ...emp });
      });

      setEmployeeData([...map.values()]);
    } catch (err) {
      console.log(err);
    } finally {
      setFormatLoading(false);
    }
  };

  useEffect(() => {
    getEmployee();
  }, [project]);


  const empIds = employeeList.map((item) => item.id);


  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };

  const bulktableRef = useRef(null);
  const handleDownload = () => {
    const table = bulktableRef.current;
    const wb = XLSX.utils.table_to_book(table, { sheet: "BOQ Attendance Details" });
    const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

    const blob = new Blob([s2ab(wbout)], {
      type: "application/vnd.ms-excel",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "BOQ Attendance Detail Format.xls";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const validateBeforeSubmit = () => {
    const newErrors = {};

    // Project validation
    if (!formData.project || formData.project === "null" || formData.project?.toString().trim() === "") {
      newErrors.project = "Please select Project";
    }

    // Month validation
    if (!formData.month || formData.month.toString().trim() === "") {
      newErrors.month = "Please select Month";
    }

    // Year validation
    if (!formData.year || formData.year.toString().trim() === "") {
      newErrors.year = "Please select Year";
    }

    // File name validation
    if (!formData.fileName || formData.fileName.toString().trim() === "") {
      newErrors.fileName = "Please select a file";
    } else if (
      !formData.fileName.endsWith(".xlsx") &&
      !formData.fileName.endsWith(".xls")
    ) {
      newErrors.fileName = "Only Excel files (.xls, .xlsx) are allowed";
    }


    SetErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };


  const checkForDuplicates = (data) => {
    const empcodes = new Map();
    const duplicates = [];

    data.forEach((row, index) => {
      const rawCode = row.emp_code;
      const code = typeof rawCode === 'number' ? rawCode.toString() : (rawCode?.trim() || "");

      if (!code) return;

      if (!empcodes.has(code)) {
        empcodes.set(code, [index + 1]);
      } else {
        empcodes.get(code).push(index + 1);
      }
    });

    empcodes.forEach((positions, code) => {
      if (positions.length > 1) {
        duplicates.push(`Code: ${code} found in position(s): ${positions.join(", ")}`);
      }
    });

    return duplicates;
  };

  const [unmatchedRows, setUnmatchedRows] = useState([]);
  const [invalidRowIndices, setInvalidRowIndices] = useState([]);
  const [duplicateRows, setDuplicateRows] = useState([]);
  const [totalDayErrors, setTotalDayErrors] = useState([]);
  const [presentDayErrors, setPresentDayErrors] = useState([]);
  const [monthYearError, setmonthYearError] = useState([]);

  const readExcel = (file) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null, raw: false });

      const headers = json[0].map(h => h?.toString().toLowerCase().trim());
      const rows = json.slice(1);

      const formattedJson = rows.map((row) => {
        const obj = {};
        headers.forEach((header, i) => {
          let value = row[i];
          if (header === "month") {
            const m = parseInt(value);
            obj["month"] = !isNaN(m) && m >= 1 && m <= 12 ? m.toString().padStart(2, "0") : null;
          } else if (header === "year") {
            const y = parseInt(value);
            obj["year"] = !isNaN(y) ? (y < 100 ? `20${y.toString().padStart(2, "0")}` : y.toString()) : null;
          } else {
            obj[header] = value !== undefined ? value : null;
          }
        });
        delete obj.project_short_name;

        return obj;
      });

      const requiredFields = [
        "emp_code", "name", "month", "year", "total_days", "present_days"
      ];
      const numericFields = ["month", "year", "total_days", "present_days"];

      const cleanedJson = formattedJson.filter((row) =>
        Object.values(row).some(val => val !== null && val.toString().trim() !== "")
      );

      const monthMismatchRows = cleanedJson
        .map((row, idx) => {
          const rowMonth = row.month?.toString().padStart(2, "0");
          const rowYear = row.year?.toString();
          const expectedMonth = monthh?.toString().padStart(2, "0");  // ✅ Pad here
          const expectedYear = yearr?.toString();


          if (rowMonth !== expectedMonth || rowYear !== expectedYear) {
            return `${toOrdinal(idx + 1)} row → ${rowMonth}/${rowYear} ≠ ${expectedMonth}/${expectedYear}`;
          }
          return null;
        })
        .filter(Boolean);

      const unmatchedRowsTemp = [];
      const invalidRowIndicesTemp = [];
      const totalDayErrors = [];
      const presentDayErrors = [];
      const duplicates = checkForDuplicates(formattedJson);

      const getDaysInMonth = (month, year) => {
        return new Date(parseInt(year), parseInt(month), 0).getDate();
      };

      const combinedData = cleanedJson.map((item, index) => {
        const empCodeFromSheet = item.emp_code?.toString().trim();
        const nameFromSheet = item.name?.toString().trim().toLowerCase();

        const hasInvalid = numericFields.some((field) => {
          const value = item[field];
          return value !== null && value !== "" && isNaN(Number(value));
        });

        if (hasInvalid) {
          invalidRowIndicesTemp.push(toOrdinal(index + 1));
        }

        const match = employeeList.find(
          (emp) => emp.emp_code?.toString().trim() === empCodeFromSheet
        );

        if (!match) {
          unmatchedRowsTemp.push(`${toOrdinal(index + 1)} row - emp_code "${item.emp_code}" not found`);
        } else if (
          match.name?.toString().trim().toLowerCase() !== nameFromSheet
        ) {
          unmatchedRowsTemp.push(`${toOrdinal(index + 1)} row - name mismatch`);
        }

        const rowMonth = item.month?.toString().padStart(2, "0");
        const rowYear = item.year?.toString();
        const totalDays = Number(item.total_days);
        const presentDays = Number(item.present_days);

        if (rowMonth && rowYear && !isNaN(totalDays)) {
          const expectedDays = getDaysInMonth(rowMonth, rowYear);
          if (totalDays !== expectedDays) {
            totalDayErrors.push(`${toOrdinal(index + 1)} row - ${monthNames[rowMonth]} has ${expectedDays} days`);
          }
        }

        if (!isNaN(presentDays) && !isNaN(totalDays) && presentDays > totalDays) {
          presentDayErrors.push(`${toOrdinal(index + 1)} row - Present days > total days`);
        }

        const manMonths =
          !isNaN(presentDays) && !isNaN(totalDays) && totalDays > 0
            ? (presentDays / totalDays).toFixed(2)  // keep as string "0.97"
            : null;


        return {
          ...item,
          employee: match?.id || null,
          project: project !== "null" ? project : null,
          man_months: manMonths
        };
      });

      setInvalidRowIndices(invalidRowIndicesTemp);
      setUnmatchedRows(unmatchedRowsTemp);
      setDuplicateRows(duplicates);
      setmonthYearError(monthMismatchRows);
      setTotalDayErrors(totalDayErrors);
      setPresentDayErrors(presentDayErrors);
      setJsonData(combinedData);
    };

    reader.readAsArrayBuffer(file);
  };

  useEffect(() => {
    setJsonData([]);
    setInvalidRowIndices("");
    setUnmatchedRows("");
    setDuplicateRows("");
    setFileName("");
    setFileSize("");
  }, [project, monthh, yearr])

  // ---- Unified file handling (validate -> set state -> parse) ----
  const processFile = (file) => {
    if (!file) return;
    const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
    if (!validFileTypes.includes(file.type)) {
      setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
      setFileName("");
      setFileSize("");
      return;
    }

    setFileName(file.name);
    setFileSize(formatFileSize(file.size));
    setDocErrors({});
    setDocInputState({ document_file: "green" });
    readExcel(file);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    processFile(file);
  };

  const handleRemoveFile = () => {
    setFileName("");
    setFileSize("");
    setJsonData([]);
    setInvalidRowIndices([]);
    setUnmatchedRows([]);
    setDuplicateRows([]);
    setTotalDayErrors([]);
    setPresentDayErrors([]);
    setmonthYearError([]);
    setDocErrors({});
    setDocInputState({});
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    processFile(file);
  };

  const [loading, setLoading] = useState(false); //loading logic
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const handleSubmit = async (e) => {

    e.preventDefault();

    if (!validateBeforeSubmit()) return;
    if (invalidRowIndices.length > 0) {
      toast.warn(`⚠️ Invalid numeric data in ${invalidRowIndices.join(", ")} row`, { autoClose: 7000 });
    }

    if (unmatchedRows.length > 0) {
      toast.warn(`⚠️ Mismatches found:\n${unmatchedRows.join("\n")}`, { autoClose: 7000 });
    }

    if (monthYearError.length > 0) {
      toast.warn(
        `⚠️ Month/Year mismatch in:\n${monthYearError.join("\n")}`,
        { autoClose: 8000 }
      );
    }
    if (totalDayErrors.length > 0) {
      toast.warn(
        `⚠️${totalDayErrors.join("\n")}`,
        { autoClose: 8000 }
      );
    }
    if (presentDayErrors.length > 0) {
      toast.warn(
        `⚠️${presentDayErrors.join("\n")}`,
        { autoClose: 8000 }
      );
    }

    if (duplicateRows.length > 0) {
      toast.warn(`⚠️ Duplicate Data found:\n${duplicateRows.join("\n")}`, { autoClose: 5000 });
    }


    if (invalidRowIndices.length > 0 || unmatchedRows.length > 0 || duplicateRows.length > 0) {
      return;
    }

    const loadingToastId = toast.loading("Loading: Please wait...");
    setShowProgressModal(true);
    setLoading(true);
    setUploadProgress(0);
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
      }
      setUploadProgress(progress);
    }, 100);
    try {

      const res = await axios.post(`${BASE_URL}/siteproject/attendancsitebulk/`, jsonData
      );
      if (res.status === 201) {
        await getAttendance();
        handleClose();
        toast.dismiss(loadingToastId);
        SetErrors('');
        setTimeout(() => {
          toast.dismiss(loadingToastId);
          toast.success("Data Added successfully.");
        }, 1000);

      }

    } catch (err) {
      clearInterval(interval);
      setUploadProgress(0);
      handleErrorToast(err);
      setLoading(false);
      toast.dismiss(loadingToastId);
    } finally {
      clearInterval(interval);

      setTimeout(() => {
        setShowProgressModal(false);
      }, 1500);

      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  // Add these two option arrays near your other option builders (e.g. near `years`)
  const monthOptions = Object.entries(monthNames).map(([value, label]) => ({
    value,
    label,
  }));

  const yearOptions = years.map((y) => ({ value: `${y}`, label: `${y}` }));

  // Selected project ka short name (merged data se)
  const selectedProjectShortName =
    Array.isArray(projectList)
      ? projectList.find((p) => String(p.id) === String(project))?.project_short_name || "-"
      : "-";
  return (
    <>
      <style>{`
        .ub-upload-zone {
          border: 2px dashed #c7cdd6;
          border-radius: 14px;
          background: #fafbfd;
          padding: 32px 20px;
          text-align: center;
          cursor: pointer;
          transition: all 0.2s ease;
          position: relative;
        }
        .ub-upload-zone:hover {
          border-color: #6366f1;
          background: #f5f5ff;
        }
        .ub-upload-zone.dragging {
          border-color: #6366f1;
          background: #eef0ff;
          transform: scale(1.01);
        }
        .ub-upload-zone.has-error {
          border-color: #e11d48;
          background: #fff1f2;
        }
        .ub-upload-zone.disabled {
          cursor: not-allowed;
          opacity: 0.55;
        }
        .ub-upload-icon-circle {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          background: linear-gradient(135deg, #6366f1, #8b5cf6);
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 14px;
          color: white;
          box-shadow: 0 4px 14px rgba(99, 102, 241, 0.3);
        }
        .ub-upload-title {
          font-size: 15px;
          font-weight: 600;
          color: #1f2937;
          margin: 0 0 4px;
        }
        .ub-upload-subtitle {
          font-size: 13px;
          color: #6b7280;
          margin: 0;
        }
        .ub-upload-browse {
          color: #6366f1;
          font-weight: 600;
          text-decoration: underline;
        }
        .ub-file-card {
          display: flex;
          align-items: center;
          gap: 12px;
          background: #f0fdf4;
          border: 1px solid #bbf7d0;
          border-radius: 12px;
          padding: 14px 16px;
          margin-top: 12px;
          animation: ub-fade-in 0.25s ease;
        }
        .ub-file-icon {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          background: #16a34a;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          flex-shrink: 0;
        }
        .ub-file-info {
          flex: 1;
          min-width: 0;
        }
        .ub-file-name {
          font-size: 14px;
          font-weight: 600;
          color: #1f2937;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .ub-file-size {
          font-size: 12px;
          color: #6b7280;
        }
        .ub-file-remove {
          background: none;
          border: none;
          cursor: pointer;
          color: #9ca3af;
          padding: 6px;
          border-radius: 8px;
          display: flex;
          transition: all 0.15s ease;
          flex-shrink: 0;
        }
        .ub-file-remove:hover {
          background: #fee2e2;
          color: #dc2626;
        }
        @keyframes ub-fade-in {
          from { opacity: 0; transform: translateY(-4px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .ub-preview-wrap {
          border: 1px solid #e5e7eb;
          border-radius: 14px;
          overflow: hidden;
          margin-top: 8px;
        }
        .ub-preview-scroll {
          overflow-x: auto;
          max-height: 340px;
          overflow-y: auto;
        }
        .ub-preview-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 13px;
          white-space: nowrap;
        }
        .ub-preview-table thead th {
          position: sticky;
          top: 0;
          background: #f8fafc;
          color: #475569;
          font-weight: 600;
          text-align: left;
          padding: 10px 14px;
          border-bottom: 2px solid #e2e8f0;
          z-index: 1;
        }
        .ub-preview-table tbody td {
          padding: 9px 14px;
          color: #334155;
          border-bottom: 1px solid #f1f5f9;
        }
        .ub-preview-table tbody tr:nth-child(even) {
          background: #fbfcfe;
        }
        .ub-preview-table tbody tr:hover {
          background: #f0f4ff;
        }
        .ub-preview-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 4px;
        }
        .ub-preview-badge {
          background: #eef2ff;
          color: #4338ca;
          font-size: 12px;
          font-weight: 600;
          padding: 4px 10px;
          border-radius: 999px;
        }
        .ub-download-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: #f8fafc;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          padding: 14px 16px;
          margin-bottom: 18px;
          gap: 12px;
        }
        .ub-download-row p {
          margin: 0;
          font-size: 13.5px;
          color: #475569;
        }
        .ub-warning-banner {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          background: #fffbeb;
          border: 1px solid #fde68a;
          color: #92400e;
          border-radius: 10px;
          padding: 10px 14px;
          margin-top: 10px;
          font-size: 13px;
          white-space: pre-line;
        }
      `}</style>

      <button
        title="Upload BOQ Bulk Attendance"
        className="btn-animated"
        onClick={handleShow}
        style={{ margin: "2px" }}
      >
        <UploadIcon /> Bulk BOQ Attendance
      </button>

      {showProgressModal ? (
        <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" />
      ) : show === true ? (
        <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal model-width80vw" size="xl">
          <Modal.Header className="modern-modal-header">
            <div className="header-content">
              <div style={{ color: "white" }}>
                <UploadIcon />
              </div>
              <div>
                <Modal.Title>Upload BOQ Bulk Attendance Data</Modal.Title>
                <p className="header-subtitle" style={{ color: "white" }}>Select project, month & year, then upload the Excel format</p>
              </div>
            </div>
            <button className="close-btn" onClick={handleClose}>
              <X size={20} />
            </button>
          </Modal.Header>

          <Modal.Body className="modern-modal-body">

            {project !== "null" && (
              <div className="ub-download-row">
                <p>
                  Download the Excel template for the selected employees.
                </p>

                {formatLoading ? (
                  <button className="btn-primaryy" disabled>
                    <Spinner
                      animation="border"
                      size="sm"
                      style={{ marginRight: 8 }}
                    />
                    Loading...
                  </button>
                ) : (
                  <button
                    onClick={handleDownload}
                    className="btn-primaryy"
                    disabled={!employeeList.length}
                  >
                    <DownloadIcon />
                    Format
                  </button>
                )}
              </div>
            )}

            <div className="section-title">
              <h4>Attendance Details</h4>
            </div>

            <div className="form-grid">
              {sessionStorage.getItem("sitemanagement_role") !== "SiteManagement" && (
                <Projects cssType="modern" usedFor="form" toggleProject={project} setToggleProject={setProject} value="id" subcompany={subCompany} error={errors.project} SetErrors={SetErrors} />
              )}
              <div title="Month" className="form-field">
                <label>
                  <Calendar size={14} /> Month<span className="required">*</span>
                </label>
                <Select
                  options={monthOptions}
                  isSearchable
                  placeholder="Select a Month"
                  value={monthOptions.find((opt) => opt.value === monthh) || null}
                  onChange={(selected) => {
                    setMonthh(selected ? selected.value : "");
                    if (errors.month) SetErrors((prev) => ({ ...prev, month: "" }));
                  }}
                  styles={CSSForSelectModern}
                />
                {errors.month && (
                  <span className="error-message font-size-text">{errors.month}</span>
                )}
              </div>

              <div title="Year" className="form-field">
                <label>
                  <Calendar size={14} /> Year<span className="required">*</span>
                </label>
                <Select
                  options={yearOptions}
                  isSearchable
                  placeholder="Select a Year"
                  value={yearOptions.find((opt) => opt.value === yearr) || null}
                  onChange={(selected) => {
                    setYearr(selected ? selected.value : "");
                    if (errors.year) SetErrors((prev) => ({ ...prev, year: "" }));
                  }}
                  styles={CSSForSelectModern}
                />
                {errors.year && (
                  <span className="error-message font-size-text">{errors.year}</span>
                )}
              </div>
            </div>

            {/* Hidden table used only as the source for the downloadable format */}
            <div className="table-css-white-background" style={{ display: "none" }}>
              <table ref={bulktableRef} className="nested-table-lightblue">
                <thead>
                  <tr className="custom-table-head-tr">
                    <th className="table-heading-text">emp_code</th>
                    <th className="table-heading-text">name</th>
                    <th className="table-heading-text">project_short_name</th>
                    <th className="table-heading-text">month</th>
                    <th className="table-heading-text">year</th>
                    <th className="table-heading-text">total_days</th>
                    <th className="table-heading-text">present_days</th>
                  </tr>
                </thead>

                <tbody>
                  {[...employeeList]
                    .sort((a, b) => a.emp_code - b.emp_code)
                    .map((data, index) => (
                      <tr key={index}>
                        <td className="summary-excel-tab br-5">{data.emp_code}</td>
                        <td className="summary-excel-tab br-5">{data.name}</td>
                        <td className="summary-excel-tab br-5">{selectedProjectShortName}</td>

                        <td className="summary-excel-tab br-5 text-center">{monthh}</td>
                        <td className="summary-excel-tab br-5 text-center">{yearr}</td>
                        <td className="summary-excel-tab br-5 text-center">{"-"}</td>
                        <td className="summary-excel-tab br-5 text-center">{"-"}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            <div className="section-title">
              <h4>Upload File</h4>
            </div>

            <div
              className={`ub-upload-zone ${isDragging ? 'dragging' : ''} ${docErrors.document_file ? 'has-error' : ''} ${project === "null" ? 'disabled' : ''}`}
              onDragOver={project === "null" ? undefined : handleDragOver}
              onDragLeave={project === "null" ? undefined : handleDragLeave}
              onDrop={project === "null" ? undefined : handleDrop}
              onClick={() => project !== "null" && fileInputRef.current?.click()}
            >
              <div className="ub-upload-icon-circle">
                <Attachment />
              </div>
              <p className="ub-upload-title">
                {project === "null" ? "Select a project first" : "Drag & drop your Excel file here"}
              </p>
              <p className="ub-upload-subtitle">
                {project === "null"
                  ? "The upload area unlocks once a project is chosen"
                  : <>or <span className="ub-upload-browse">browse</span> to choose a file &nbsp;·&nbsp; .xlsx or .xls</>}
              </p>
              <input
                ref={fileInputRef}
                id="document_file"
                name="document_file"
                type="file"
                accept=".xlsx, .xls"
                onChange={handleFileChange}
                disabled={project === "null"}
                style={{ display: "none" }}
              />
            </div>

            {docErrors.document_file && (
              <div className="tab-error-message" style={{ marginTop: '10px' }}>
                <AlertCircle size={14} />
                <span>{docErrors.document_file}</span>
              </div>
            )}
            {errors.fileName && !docErrors.document_file && (
              <div className="tab-error-message" style={{ marginTop: '10px' }}>
                <AlertCircle size={14} />
                <span>{errors.fileName}</span>
              </div>
            )}

            {fileName && !docErrors.document_file && (
              <div className="ub-file-card">
                <div className="ub-file-icon">
                  <FileText size={20} />
                </div>
                <div className="ub-file-info">
                  <div className="ub-file-name">{fileName}</div>
                  <div className="ub-file-size">{fileSize}{jsonData?.length ? ` · ${jsonData.length} records found` : ''}</div>
                </div>
                <button type="button" className="ub-file-remove" onClick={handleRemoveFile} title="Remove file">
                  <X size={18} />
                </button>
              </div>
            )}

            {(invalidRowIndices.length > 0 || unmatchedRows.length > 0 || duplicateRows.length > 0 ||
              monthYearError.length > 0 || totalDayErrors.length > 0 || presentDayErrors.length > 0) && (
                <div className="ub-warning-banner">
                  <AlertCircle size={16} style={{ flexShrink: 0, marginTop: 1 }} />
                  <div>
                    {invalidRowIndices.length > 0 && <div>Invalid numeric data in {invalidRowIndices.join(", ")} row</div>}
                    {unmatchedRows.length > 0 && <div>{unmatchedRows.join("\n")}</div>}
                    {monthYearError.length > 0 && <div>{monthYearError.join("\n")}</div>}
                    {totalDayErrors.length > 0 && <div>{totalDayErrors.join("\n")}</div>}
                    {presentDayErrors.length > 0 && <div>{presentDayErrors.join("\n")}</div>}
                    {duplicateRows.length > 0 && <div>{duplicateRows.join("\n")}</div>}
                  </div>
                </div>
              )}

            {fileName !== "" && jsonData.length > 0 && (
              <>
                <div className="ub-preview-header">
                  <div className="section-title" style={{ marginBottom: 0 }}>
                    <h4 style={{ margin: 0 }}>Preview</h4>
                  </div>
                  <span className="ub-preview-badge">{jsonData.length} records</span>
                </div>

                <div className="ub-preview-wrap">
                  <div className="ub-preview-scroll table-box scroll-container-table">
                    <table className="ub-preview-table">
                      <thead className="table-heading">
                        <tr>
                          <th>S.no.</th>
                          <th>Emp Code</th>
                          <th>Name</th>
                          <th>Project</th>
                          <th>Month</th>
                          <th>Year</th>
                          <th>Total Days</th>
                          <th>Present Days</th>
                          <th>Man Months</th>
                        </tr>
                      </thead>
                      <tbody>
                        {jsonData.map((data, index) => (
                          <tr key={index}>
                            <td>{index + 1}.</td>
                            <td>{data.emp_code}</td>
                            <td>{data.name}</td>
                            <td>{selectedProjectShortName}</td>
                            <td>{data.month}</td>
                            <td>{data.year}</td>
                            <td>{data.total_days}</td>
                            <td>{data.present_days}</td>
                            <td>{data.man_months}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}

            <div className="form-actions">
              <button type="button" className="btn-secondaryy" onClick={handleClose}>
                Cancel
              </button>
              <button type="button" className="btn-primaryy" onClick={handleSubmit} disabled={!fileName}>
                <UploadIcon />
                <span>Upload</span>
              </button>
            </div>

            <ToastContainer
              position="top-center"
              autoClose={1000}
              hideProgressBar={false}
              newestOnTop={true}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </Modal.Body>
        </Modal>
      ) : ""}
    </>
  )
};

// const DeleteboqAttandance = ({ i, getAttendance }) => {
//   const [show, setShow] = useState(false);

//   const handleClose = () => setShow(false);
//   const handleShow = () => {
//     setShow(true);
//   };
//   const [loading, setLoading] = useState(false); //loading logic
//   const [uploadProgress, setUploadProgress] = useState(0);
//   const [showProgressModal, setShowProgressModal] = useState(false);
//   const [success, setSuccess] = useState(false)
//   const handleFormSubmitDelete = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setShowProgressModal(true);

//     const loadingToastId = toast.loading("Loading: Please wait...");

//     let progress = 0;
//     const interval = setInterval(() => {
//       progress += 10;
//       setUploadProgress(progress);
//       if (progress >= 100) clearInterval(interval);
//     }, 100);

//     try {
//       const res = await axios.delete(`${BASE_URL}/siteproject/attendancesitesupdate/${i.id}/`);

//       if (res.status === 200) {
//         await getAttendance();
//         handleClose();

//         setTimeout(() => {
//           toast.dismiss(loadingToastId);
//           toast.success("Data Deleted successfully.");
//         }, 500);
//       } else {
//         throw new Error("Unexpected response status: " + res.status);
//       }
//     } catch (err) {
//       clearInterval(interval); // Stop simulated progress
//       setUploadProgress(0); // Optional: reset progress
//       handleErrorToast(err); // Your own function for error messages
//       toast.dismiss(loadingToastId);
//     } finally {
//       setTimeout(() => {
//         setShowProgressModal(false); // Hide modal even after error
//       }, 1000);
//       setLoading(false);
//     }
//   };


//   return (
//     <>
//       <button
//         title="Delete Boq Attendance"
//         className="model-delete-button"
//         onClick={handleShow}
//       >
//         <DeleteDustbin />
//       </button>
//       {
//         showProgressModal ?
//           <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" /> :
//           <Modal
//             show={show}
//             onHide={handleClose}
//             dialogClassName="request-leave width-40vw"
//           >
//             <Modal.Header closeButton>
//               <Modal.Title>Delete BOQ Attendance</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//               <div className="parent-div">
//                 Are You Sure You Want to delete attandance data of {i.employee_name}
//                 <div className="button-models">
//                   <button
//                     className="model-button   font-weight500    "
//                     onClick={handleClose}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     onClick={handleFormSubmitDelete}
//                     className="model-button   font-weight500    model-button-delete"
//                   >
//                     Delete
//                   </button>
//                 </div>
//               </div>
//               <ToastContainer
//                 position="top-center"
//                 autoClose={1000}
//                 hideProgressBar={false}
//                 newestOnTop={true}
//                 closeOnClick
//                 rtl={false}
//                 pauseOnFocusLoss
//                 draggable
//                 pauseOnHover
//               />
//             </Modal.Body>
//           </Modal>
//       }

//     </>
//   );
// };

const DeleteboqAttandance = ({ i, getAttendance }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    setShowProgressModal(true);
    setLoading(true);
    setUploadProgress(0);

    const loadingToastId = toast.loading("Loading: Please wait...");

    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
      }
      setUploadProgress(progress);
    }, 100);

    try {
      const res = await axios.delete(`${BASE_URL}/siteproject/attendancesitesupdate/${i.id}/`);

      if (res.status === 200) {
        await getAttendance();
        toast.dismiss(loadingToastId);
        toast.success("Data Deleted successfully.");
        setShow(false);
      } else {
        throw new Error("Unexpected response status: " + res.status);
      }
    } catch (err) {
      clearInterval(interval);
      setUploadProgress(0);
      handleErrorToast(err);
      toast.dismiss(loadingToastId);
    } finally {
      clearInterval(interval);
      setTimeout(() => {
        setShowProgressModal(false);
      }, 1500);
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button title="Delete Boq Attendance" className="model-delete-button-modern" style={{ backgroundColor: "#00000075" }} onClick={handleShow}>
        <DeleteDustbin modernButton="true" />
      </button>

      {showProgressModal ? (
        <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" />
      ) : (
        <Modal show={show} onHide={handleClose} dialogClassName="modern-required-modal" centered>
          <Modal.Header className="modern-modal-header requirement-modal-header">
            <div className="header-content">
              <div className="requirement-header-icon">
                <Trash2 size={22} />
              </div>
              <div>
                <Modal.Title>Delete BOQ Attendance</Modal.Title>
                <p className="header-subtitle" style={{ color: "white" }}>
                  This action cannot be undone
                </p>
              </div>
            </div>
            <button className="close-btn" onClick={handleClose}>
              <X size={20} />
            </button>
          </Modal.Header>

          <Modal.Body className="modern-modal-body requirement-modal-body">
            <div className="requirement-mode-summary" style={{ marginBottom: '20px' }}>
              <AlertCircle size={16} />
              <span>
                Are you sure you want to delete attendance data of <strong>{i.employee_name}</strong>?
              </span>
            </div>

            <div className="submit-buttons" style={{ justifyContent: 'flex-end' }}>
              <button type="button" className="btn-secondaryy" onClick={handleClose} disabled={loading}>
                Cancel
              </button>
              <button
                type="button"
                className="btn-primaryy"
                style={{ background: "#dc3545", borderColor: "#dc3545" }}
                onClick={handleFormSubmitDelete}
                disabled={loading}
              >
                {loading ? <Loader size={18} className="spinning" /> : <Trash2 size={18} />}
                <span>{loading ? 'Deleting...' : 'Delete'}</span>
              </button>
            </div>

            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

const STATUS_CLASS = {
  P: "att-status-P",
  A: "att-status-A",
  L: "att-status-L",
  H: "att-status-H",
  W: "att-status-W",
};

const Attendance = () => {
  const siteRole = sessionStorage.getItem("sitemanagement_role");

  const today = new Date();
  today.setDate(today.getDate() - 1);
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const [monthh, setMonthh] = useState(`${month}`);
  const day = today.getDate();
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];
  const monthName = monthNames[monthh - 1];

  const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
    .toString()
    .padStart(2, "0")}`;
  var datearray = formattedDate.split("-");
  var newdate = datearray[0] + "-" + datearray[1] + "-" + datearray[2];

  const [yearr, setYearr] = useState(`${year}`);

  const projectID = sessionStorage.getItem("sitemanagement_project");
  const [project, setProject] = useState(projectID ? projectID : "null");

  // ---------- Show/hide filters ----------
  const [showFilters, setShowFilters] = useState(true);

  useEffect(() => {
    getAllattendancedata();
  }, [monthh, yearr, monthName]);

  useEffect(() => {
    getSubCompany();
  }, []);

  const siteSubCompany = sessionStorage.getItem("sitemanagement_project_sub_company");

  const [subCompany, setSubCompany] = useState(siteSubCompany ? siteSubCompany : "null");
  const [allattendance, setAllattendance] = useState([]);
  const [subbuffer, setSubBuffering] = useState(true);
  const [buffer, setBuffering] = useState(true);

  const [subcompanyList, setSubCompanyList] = useState([]);
  const getSubCompany = async () => {
    setSubBuffering(true);
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
      setSubCompanyList(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setSubBuffering(false);
    }
  };

  const [loading, setLoading] = useState(false);
  const [projectList, setProjectList] = useState([]);

  const getproject = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/siteproject/projectfilterbysubcompany/null/`
      );

      const splitCodeParts = (code) => {
        const parts = code.trim().split("/");
        const firstPart = parts.slice(0, -1).join("/");
        const lastPart = parts.pop();
        const match = lastPart.match(/^(\d+)?([A-Za-z]+)$/);
        if (match) {
          return {
            firstPart,
            numericPart: match[1] ? parseInt(match[1], 10) : 0,
            alphaPart: match[2],
          };
        }
        return { firstPart, numericPart: 0, alphaPart: "" };
      };

      const sortedList = response.data.sort((a, b) => {
        const aParts = splitCodeParts(a.site_prcode);
        const bParts = splitCodeParts(b.site_prcode);
        if (aParts.firstPart !== bParts.firstPart) {
          return aParts.firstPart.localeCompare(bParts.firstPart);
        }
        if (aParts.alphaPart !== bParts.alphaPart) {
          return aParts.alphaPart.localeCompare(bParts.alphaPart);
        }
        return aParts.numericPart - bParts.numericPart;
      });

      setProjectList(sortedList);
    } catch (error) {
      alert(error);
    }
  };

  let getAllattendancedata = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/monthlyattendnaceall/${monthh}/${yearr}/${project}/${subCompany}/`
      );

      const getAlphaNumericParts = (code) => {
        const match = code.match(/^([A-Za-z]+)(\d+)$/);
        if (match) {
          return { alphaPart: match[1], numericPart: parseInt(match[2], 10) };
        } else {
          return { alphaPart: "", numericPart: 0 };
        }
      };

      const sortedList = res.data.sort((a, b) => {
        const { alphaPart: alphaA, numericPart: numericA } = getAlphaNumericParts(a.emp_code);
        const { alphaPart: alphaB, numericPart: numericB } = getAlphaNumericParts(b.emp_code);

        if (alphaA !== alphaB) {
          return alphaA.localeCompare(alphaB);
        } else {
          return numericA - numericB;
        }
      });
      setAllattendance(sortedList);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  const refreshdata = async () => {
    setBuffering(true);
    await getAllattendancedata();
    setBuffering(false);
  };

  useEffect(() => {
    getAllattendancedata();
  }, [project, month, year, subCompany]);

  const getAllDatesOfMonth = (month, year) => {
    const numberOfDaysInMonth = new Date(year, month, 0).getDate();
    const dates = [];
    const datees = [];

    for (let i = 1; i <= numberOfDaysInMonth; i++) {
      const date = new Date(year, month - 1, i);
      const day = date.getDate();
      const formatttedDatee = `${day.toString().padStart(2, "0")}`;
      datees.push({ date: formatttedDatee });
      const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;
      dates.push({ date: formattedDate });
    }

    return dates;
  };

  const dates = getAllDatesOfMonth(monthh, yearr).map((date, index) => ({
    ...date,
    index,
  }));

  const getAllDatessOfMonth = (month, year) => {
    const numberOfDaysInMonth = new Date(year, month, 0).getDate();
    const datees = [];

    for (let i = 1; i <= numberOfDaysInMonth; i++) {
      const date = new Date(year, month - 1, i);
      const day = date.getDate();
      const formatttedDatee = `${day.toString().padStart(2, "0")}`;
      datees.push({ date: formatttedDatee });
    }

    return datees;
  };

  const datees = getAllDatessOfMonth(monthh, yearr);

  const [filteredEmployee, setFilteredEmployee] = useState([]);
  const [selectedName, setName] = useState("");
  const [selectedDep, setDep] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedDivision, setDivision] = useState(
    `${sessionStorage.getItem("company")}`
  );

  const applyFilters = () => {
    let filteredData = allattendance;

    if (selectedStatus !== "") {
      filteredData = filteredData.filter(
        (employee) => employee.employee_status === selectedStatus
      );
    }

    if (selectedName) {
      const lowercaseSelectedName = selectedName.toLowerCase();
      filteredData = filteredData.filter((employee) => {
        const nameMatch = employee.name?.toLowerCase().includes(lowercaseSelectedName);
        const empCodeMatch = employee.emp_code.toString().includes(selectedName);
        const depMatch = employee.desigantion_name?.toLowerCase().includes(lowercaseSelectedName);
        return nameMatch || empCodeMatch || depMatch;
      });
    }

    setFilteredEmployee(filteredData);
  };

  useEffect(() => {
    getproject();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [selectedName, selectedStatus, allattendance]);

  const [selectedIndex, setSelectedIndex] = useState(-1);

  const handleClick = (index) => {
    setSelectedIndex(index);
  };

  const tableRef = useRef(null);
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 10;
  const endYear = currentYear;
  const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);

  // ---------- Clear all filters logic ----------
  const hasActiveFilters =
    (siteRole !== "SiteManagement" && subCompany !== "null") ||
    (siteRole !== "SiteManagement" && project !== "null") ||
    selectedStatus !== "active" ||
    selectedName !== "" ||
    monthh !== `${month}` ||
    yearr !== `${year}`;

  const clearAllFilters = () => {
    if (siteRole !== "SiteManagement") {
      setSubCompany("null");
      setProject("null");
    }
    setSelectedStatus("active");
    setName("");
    setMonthh(`${month}`);
    setYearr(`${year}`);
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <div className="progress-modern-container">

        {/* Filter bar */}
        {showFilters && (
          <div className="filter-bar-attractive">
            {siteRole !== "SiteManagement" && siteSubCompany !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" && (
              <div className={`filter-chip ${subCompany !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
                <div className="filter-chip-content">
                  <SubCompanyModern toggleCompany={subCompany} setToggleCompany={setSubCompany} cssType="modern" />
                </div>
              </div>
            )}

            {siteRole !== "SiteManagement" && (
              <div className={`filter-chip ${project !== "null" ? "active" : ""}`} style={{ backgroundColor: "white", paddingTop: '0px', paddingBottom: "0px" }}>
                <div className="filter-chip-content" style={{ backgroundColor: "white" }}>
                  <Projects usedFor="filter"
                    value="id"
                    toggleProject={project}
                    setToggleProject={setProject}
                    subcompany={subCompany} />
                </div>
              </div>
            )}

            <div className="filter-chip">
              <div className=""><Clock size={13} /></div>
              <div className="filter-chip-content">
                <select
                  value={selectedStatus}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                  className="modern-select"
                >
                  <option value="">All</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
            </div>

            <div className="filter-chip" style={{ minWidth: '220px' }}>
              <div><Search size={13} /></div>
              <div style={{ width: '100%' }}>
                <input
                  className="modern-select"
                  style={{ width: '100%' }}
                  placeholder="Name / Emp code / Email"
                  type="text"
                  value={selectedName}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
            </div>
            <div className="filter-chip" style={{ padding: '0px' }}>
              <div className="filter-chip-content">
                <MonthModern filterMonth={monthh} setFilterMonth={setMonthh} cssType="modern" />
              </div>
            </div>
            <div className="filter-chip" style={{ padding: '0px' }}>
              <div className="filter-chip-content">
                <YearModern filterYear={yearr} setFilterYear={setYearr} cssType="modern" />
              </div>
            </div>

            {hasActiveFilters && (
              <button className="clear-filters-btn" onClick={clearAllFilters}>
                <X size={13} />
                Clear
              </button>
            )}
          </div>
        )}

        {/* Stats + toggle + actions */}
        <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
          <div className="stats-minimal-row">
            <div className="stat-minimal-item">
              <Users size={14} />
              <span>Showing</span>
              <strong>{filteredEmployee.length} of {allattendance.length} employees</strong>
            </div>
          </div>

          <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
            <button
              className="toggle-filters-btn"
              onClick={() => setShowFilters(!showFilters)}
            >
              <Filter size={14} />
              <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
              {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
            </button>

            {siteRole !== "ViewAccess" && (
              <div className="att-actions">
                <DownloadTableExcel
                  filename={
                    selectedDivision === ""
                      ? `${monthName}-AttendanceSheet`
                      : `${monthName}-AttendanceSheet-${selectedDivision}`
                  }
                  sheet="users"
                  currentTableRef={tableRef.current}
                >
                  <button title="Download excel" className="att-icon-btn" style={{ backgroundColor: "black" }}>
                    <DownloadCloud color="white" />
                  </button>
                </DownloadTableExcel>

                <UploadAttendanceBulk2 getAttendanceData={getAllattendancedata} />
              </div>
            )}
          </div>
        </div>

        {/* Table card */}
        <div className="att-card">
          <div className="att-table-header">
            <div className="att-table-title-group">
              <h2 className="att-table-title">Attendance</h2>
              <span className="att-count-pill">
                {filteredEmployee.length} of {allattendance.length}
              </span>
            </div>

            {buffer || subbuffer ? (
              <div className="att-spinner-sm" />
            ) : (
              <button
                onClick={refreshdata}
                disabled={buffer}
                className="att-icon-btn"
                title="Refresh"
                style={{ backgroundColor: "black" }}
              >
                <Refresh color="white" />
              </button>
            )}
          </div>

          <div className="att-table-scroll">
            <table ref={tableRef} id="my-table" className="att-table">
              <thead>
                <tr className="att-thead-top">
                  <th rowSpan="2" className="att-th-frozen att-col-sno">S.no.</th>
                  <th rowSpan="2" className="att-th-frozen att-col-empcode">Emp. Code</th>
                  <th rowSpan="2" className="att-th-frozen att-col-name att-frozen-last">Name</th>
                  <th rowSpan="2">Joining Date</th>
                  <th rowSpan="2">Designation</th>
                  <th colSpan={datees.length} className="att-th-center">
                    Attendance
                  </th>
                  <th colSpan="5" className="att-th-center">
                    Stats
                  </th>
                </tr>
                <tr className="att-thead-bottom">
                  {datees.map((date) => (
                    <th key={date.date}>{date.date}</th>
                  ))}
                  <th>P</th>
                  <th>A</th>
                  <th>L</th>
                  <th>H</th>
                  <th>W</th>
                </tr>
              </thead>

              {buffer ? (
                <tbody>
                  <tr>
                    <td colSpan={9 + datees.length} style={{ padding: "64px 0" }}>
                      <div className="att-spinner-lg" />
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody>
                  {filteredEmployee
                    .sort((a, b) => a.emp_code - b.emp_code)
                    .map((data, index) => {
                      const isSelected = index === selectedIndex;
                      const isInactive = data.employee_status === "inactive";
                      const rowClass = [
                        "att-row",
                        isSelected ? "att-row--selected" : index % 2 === 0 ? "att-row--even" : "att-row--odd",
                        isInactive ? "att-row--inactive" : "",
                      ].join(" ");

                      return (
                        <tr key={index} onClick={() => handleClick(index)} className={rowClass}>
                          <td className="att-td att-td-frozen att-col-sno">{index + 1}</td>
                          <td className="att-td att-td-frozen att-td--strong att-col-empcode">{data.emp_code}</td>
                          <td className="att-td att-td-frozen att-col-name att-frozen-last">{data.name}</td>
                          <td className="att-td">{data.joining_date}</td>
                          <td className="att-td">{data.desigantion_name}</td>

                          {dates.map((date) => {
                            const attendanceForDate = data.attendances.find(
                              (attendance) => attendance.date === date.date
                            );
                            const inTime = attendanceForDate?.in_time ?? "-";
                            const outTime = attendanceForDate?.out_time ?? "-";
                            const attstat = attendanceForDate?.status ?? "-";
                            const statusClass = STATUS_CLASS[attstat] ?? "att-status-default";

                            return (
                              <td
                                key={date.date}
                                title={`Date: ${date.date}\nIn Time: ${inTime}\nOut Time: ${outTime}\nAttendance Status: ${attstat}\n`}
                                className="att-td-day"
                              >
                                <span className={`att-badge-day ${statusClass}`}>{attstat}</span>
                              </td>
                            );
                          })}

                          <td className="att-td-stat">
                            <span className="att-badge-stat att-stat-present">{data.present}</span>
                          </td>
                          <td className="att-td-stat">
                            <span className="att-badge-stat att-stat-absent">{data.absent}</span>
                          </td>
                          <td className="att-td-stat">
                            <span className="att-badge-stat att-stat-leave">{data.leave}</span>
                          </td>
                          <td className="att-td-stat">
                            <span className="att-badge-stat att-stat-holiday">{data.holiday}</span>
                          </td>
                          <td className="att-td-stat">
                            <span className="att-badge-stat att-stat-weeklyoff">{data.weeklyoff}</span>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              )}
            </table>
          </div>

          {/* Legend */}
          <div className="att-legend">
            <span><strong>P</strong> = Present</span>
            <span><strong>A</strong> = Absent</span>
            <span><strong>H</strong> = Holiday</span>
            <span><strong>W</strong> = Weekly Off</span>
            <span><strong>L</strong> = Leave</span>
          </div>
        </div>
      </div>
    </>
  );
};
export { Attendance, DeleteboqAttandance, AddBulkboqAttendance, AddSiteAttendence, GetAttendance, }
